<!--除头部外的主体页面-->
<template>
  <div class="calendar pr">
    <!-- 主体部分除日例外左侧 -->
    <div class="calendarLeft" @click="closeCreateBox">
      <!-- <calendar-left :bookmark="bookmark" :addTemplateSucc="addTemplateSucc" @changeSource="chooseSource" @listChange="listChange" @currentSelectData="currentSelectData" @isNext="isNext" @editTemplate="editTemplate">
      </calendar-left> -->
      <page-left-resource :WhichPage="'Scheduler'" :bookmark="bookmark" @currentSelectData="currentSelectData" @editTemplate="editTemplate"></page-left-resource>
    </div>

    <!-- 日历左边放大功能 -->
    <magnify :dateInfo="dateInfo" :visible.sync="dateInfo.show" v-if="dateInfo.show" :events="events" :fixedDevice="selectR" :dynamicDevice="selectSource" @close="closeCreateBox"></magnify>
    <!-- 日历左边放大滚动条 -->
    <div class="magnifying" v-show="!IsShowTemplate&&!displayType" >
      <div class="header"></div>
      <div class="body">
        <div class="mnf_content" :style="{ height: `${calendarHeight}px` }">
          <div class="mnf_btn" v-for="(item, index) in magnifyingBtns" :key="index">
            <button class="ellipsis" @click="openCalendar(index)">
              {{ $t("lang.magnifying") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 日历主体 -->
    <div class="calendar_box" id="listenRightClick" v-show="!IsShowTemplate">
      <!-- 播放剩余时间？ -->
      <div class="count_down" :title="`${nextEvent.tname},${nextEvent.rname},${nextEvent.eventName},${countDownTime}`" :class="{ visib: countDownTime != '00:00:00' }">
        <span class="f_left ellipsis">{{ nextEvent.tname }}</span>
        <span class="f_left ellipsis">,{{ nextEvent.rname }}</span>
        <span class="f_left ellipsis">,{{ nextEvent.eventName }}</span>
        <span class="f_left ellipsis">,{{ countDownTime }}</span>
      </div>
      <!-- 年月日的选择 -->
      <div class="cal_date_opt">
        <i class="el-icon-arrow-left pointer" @click="preDate"></i>
        <el-date-picker v-model="dateTitle" type="date" popper-class="pick_date_time" class="date_option" @change="changeDateView"></el-date-picker>
        <i class="el-icon-arrow-right pointer" @click="nextDate"></i>
        <i v-if="dayForm.WeekSwitch" :disabled="CloneDisabled.disableButton" class="iconfont icon-save" @click="SaveWeekTemplate"></i>
        <i v-if="dayForm.WeekSwitch" :disabled="CloneDisabled.disableButton" class="iconfont icon-clear" @click="ClearWeekEvent"></i>
      </div>
      <!-- 时间日历插件 -->
      <full-calendar class="calendarEventWrap draggable_box" ref="calendar" v-if="calendarFlag" v-loading="loadingCalendar&&!displayType" element-loading-background="rgba(0, 0, 0, .6)" :event-sources="eventSources" @event-selected="eventSelected" @event-created="eventCreated" @day-click="dayClick" :key="keycount" :config="calendarConfig"></full-calendar>
      <!-- 日视图 -->
      <template-day-list v-if="displayType&&viewType=='agendaDay'" v-loading="loadingCalendar" element-loading-background="rgba(0, 0, 0, .6)" :viewType='viewType'  :eventDayList='eventDayList'  @fillCreateBox='ClickEvent' @createEvent='createEvent' :curDate='curDate' :TimeQuantum='TimeQuantum'></template-day-list>
      <!-- 周视图 -->
      <template-list v-if="displayType&&viewType=='agendaWeek'" v-loading="loadingCalendar" element-loading-background="rgba(0, 0, 0, .6)" @fillCreateBox='ClickEvent' @createEvent='createEvent' :eventModesList='eventModesList' :headWith='headWith' :curDate='curDate' :TimeQuantum='TimeQuantum' ></template-list>
      <!-- 创建框 -->
      <popup-box v-if="EventMotion.switch" :picthOnEvent="picthOnEvent" :EventMotion="EventMotion.motion" :fixedDevice="selectR" :BoxPosition="createBox" @closeCreateBox="closeCreateBox" @OperationSuccess="OperationSuccess" :displayType='displayType'></popup-box>
    </div>

    <!-- 模板 -->
    <div class="CreateTemplate" v-if="IsShowTemplate == 1">
      <event-template :WeekTitle="TemplateScheduleType" :TemplateBodyMessage="TemplateBodyMessage" :fixedDevice="selectR" :dynamicDevice="selectSource" @CancelTemplate="CancelTemplate"></event-template>
    </div>
    <!-- program模板 -->
    <div class="ProgramTemplateEdit" v-if="IsShowTemplate == 2">
      <template-page-right @closeProgramTemplate="CancelTemplate"></template-page-right>
    </div>
    <!-- 保存当天模板 -->
    <el-dialog class="SaveDayTemplate" :title="$t('lang.saveTip')" :visible.sync="daySaveVisible" width="600px" :rules="{ required: true }">
      <div>
        <div>{{$t('lang.name')}}</div>
        <el-input v-model="dayForm.name"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel" @click="daySaveVisible = false">{{ $t("lang.cancel") }}</el-button>
        <el-button class="save" type="primary" @click="daySaveName()">{{ $t("lang.Confirm") }}</el-button>
      </div>
    </el-dialog>
    <!-- 判断是否需要取整 -->
    <media-time-floor v-if="MediaTimeFloor.show" :MediaTimeFloor="MediaTimeFloor" @RoundSelectRes="RoundSelectRes"></media-time-floor>
    <!-- 右击事件操作 -->
    <right-click-operation v-if="OperationStyle.Switch" :OperationStyle="OperationStyle" :PitchEventList="PitchEventList" @DeleteMoreEvent="DeleteMoreEvent" @CopyandMoveEvent="CopyandMoveEvent"></right-click-operation>
    <time-select v-if="MoveandCopyTime.show" :MoveandCopyTime="MoveandCopyTime" :PitchEventList="PitchEventList" @ApplyStartFrom="ApplyStartFrom"></time-select>
     <!-- 强制填充选项框 -->
    <force-fill-select v-if="forceFillMessage.show" :forceFillMessage='forceFillMessage' @forceFillSelect='forceFillSelect'></force-fill-select>
    <scheduler-drag-time v-if="SchedulerDragTime.show" :SchedulerDragTime='SchedulerDragTime' @DragTimeSelect='DragTimeSelect' ></scheduler-drag-time>
  </div>
</template>
<script>
import Outil from '../../assets/js/utils.js'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'
import { mapState, mapMutations } from 'vuex'
import toTips from '@/assets/js/toTipsObj'
import magnify from './magnify'
// import calendarLeft from './PlayoutLeft'
import PageLeftResource from '@/components/common/PageLeftResource.vue'
import Bus from '@/assets/js/vueBus.js'
import EventTemplate from './EventTemplate.vue'
import PopupBox from '@/components/common/PopupBox.vue'
import TemplatePageRight from '@/views/ProgramTemplate/TemplatePageRight.vue'
import TimeSelect from './common/TimeSelect.vue'
import { scheduleAnalyze } from '../../assets/js/googleAnalyze/playout.js'
import NotManyEdit from '@/assets/js/NotManyEdit.js'
import TemplateList from './TemplateList.vue'
import TemplateDayList from './TemplateDayList.vue'
import { TimetableSideConfig } from '@/assets/js/common/ParamConfig.js'
import ForceFillSelect from '@/components/common/ForceFillSelect.vue'
import MediaTimeFloor from '@/components/file/MediaTimeFloor.vue'
import commonRequest from '@/assets/js/common/commonRequest.js'
import { listEvent } from '@/service/playout'
import SchedulerDragTime from '@/views/Playout/common/SchedulerDragTime.vue'
import moment from 'moment-timezone'
import RightClickOperation from '@/views/Playout/common/RightClickOperation.vue'

const googleKey = 'playout'
export default {
  components: {
    magnify,
    EventTemplate,
    PopupBox,
    TimeSelect,
    PageLeftResource,
    TemplatePageRight,
    TemplateList,
    TemplateDayList,
    ForceFillSelect,
    MediaTimeFloor,
    SchedulerDragTime,
    RightClickOperation
  },
  props: ['bookmark', 'temRenameStatus'],
  data () {
    return {
      // Shift加点击快捷节选中的事件
      ShiftClickData: {},
      // 显示事件哪些数据
      displayEventMetadata: '',
      // 时区
      homeTimeZone: 'America/New_York',
      ListQuestRecord: 0,
      // 存储错位事件
      DislocationEvent: {},
      DislocationEvent1: {},
      // 最近两个事件
      showEventObj: [],
      // 记录滚动高度
      RecordScrollHeight: 0,
      // 夏令时时间
      DstTime: {
        isDst: false
      },
      // move，copy操作选择时间
      MoveandCopyTime: {
        type: 'Move',
        show: false,
        loading: false
      },
      // 右击操作样式
      OperationStyle: {
        Switch: false
      },
      isMac: false,
      // MAC的ctrl是否按下
      MACCtrl: false,
      // ctrl是否按下
      CtrlDown: false,
      // ctrl是否选中event
      CtrlPitch: false,
      // ctrl选中event的列表
      PitchEventList: [],
      // 页面所有事件
      PageAllEvent: [],
      // 选中事件对象
      picthOnEvent: {},
      // 弹窗的动作,对于事件
      EventMotion: {
        switch: false,
        motion: 0
      },
      // 是否点击图标
      IsClickIcon: false,
      // 模板类型
      TemplateScheduleType: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      // 查询模板的信息
      TemplateBodyMessage: {},
      // 是否显示模板
      IsShowTemplate: 0,
      editEventStart: '', // 编辑时的添加时间
      currentSelectPeerid: '', // 所选rid
      daySaveVisible: false, // 按天保存
      dayTime: '', // 按天保存
      dayForm: {
        type: 2, // 1周模板 2天模板
        name: '',
        WeekSwitch: true
      },
      // 使用模板
      templateDetailStatus: false,
      renameForm: {},
      addTemplateSucc: false, // 模板添加成功后渲染左侧列表
      type: '', // 保存模板类型
      keycount: 0,
      // 日历左边放大
      dateInfo: {
        show: false,
        date: {
          start: '',
          end: '',
          date: [],
          weekTitle: []
        }
      },
      dateArr: {
        date: [],
        weekTitle: []
      },
      calendarFlag: false,
      eventListFlag: true,
      loadingCalendar: false,
      calendarHeight: '',
      countDownTime: '00:00:00',
      nextEvent: {
        tname: '',
        rname: '',
        eventName: ''
      },
      timer: {
        countDown: null,
        events: null,
        curEvent: null,
        refetchEvent: null
      },
      event: {
        title: '',
        source: '',
        rname: '',
        tname: '',
        description: '',
        destination: '',
        delay: '',
        bit: '',
        reporter: '',
        startTime: '',
        stopTime: '',
        color: 'rgb(15, 190, 113)',
        rpeerid: '',
        tpeerid: '',
        ttype: '',
        turl: '',
        eventId: '',
        duration: '',
        // spliceType: '',
        prerollTime: ''
      },
      deleteId: '',
      loading: {
        source: false
      },
      addBookingParam: {
        title: '',
        rpeerid: '',
        tpeerid: '',
        startTime: '',
        endTime: '',
        description: '',
        delay: '',
        reporter: '',
        color: '',
        ttype: '',
        turl: '',
        bitrate: '',
        tname: ''
      },
      calendar: {
        searchS: false,
        searchR: false,
        filterBox: false
      },
      pickerDateBeg: {
        disabledDate (time) {
          var date = Outil.getDateTime()
          return (
            time.getTime() <
            new Date(
              `${date.year}/${date.month}/${date.day} 00:00:00`
            ).getTime()
          )
        }
      },
      pickerDateEnd: {
        disabledDate (time) {
          var date = Outil.getDateTime()
          return (
            time.getTime() <
            new Date(
              `${date.year}/${date.month}/${date.day} 00:00:00`
            ).getTime()
          )
        }
      },
      filterList: [],
      checkAll: true,
      isIndeterminate: false,
      timeFlag: 0,
      createBox: {
        // 创建框的位置
        left: 0,
        top: 0,
        triangle: false,
        bottom: false
      },
      createStartTime: '',
      createStopTime: '',
      startDate: '',
      dateTitle: '', // 日历头部时间title
      events: [],
      dragEvent: {},
      eventFrom: '',
      lastSourceCondition: '',
      calendarConfig: {
        // full-calendar的配置参数
        // buttonText: this.viewBtns,
        // timezoneParam: 'UTC',
        // timezone: 'America/Anchorage',
        buttonText: {
          today: this.$t('lang.todayKey'),
          month: this.$t('lang.monthKey'),
          week: this.$t('lang.weekKey'),
          day: this.$t('lang.dayKey')
        },
        header: {
          left: '',
          center: 'prev,title,next'
        },
        navLinks: true,
        selectable: true,
        selectHelper: true,
        dayRender: (date, cell) => { },
        firstDay: 1, // 设置周几为第一天
        columnFormat: 'ddd M/D',
        // slotDuration: '00:00:10',
        defaultView: 'agendaWeek',
        allDaySlot: false,
        firstHour: 1,
        slotEventOverlap: false, // 事件不可重叠
        editable: false, // 事件不可拖动缩放
        eventDurationEditable: false,
        eventStartEditable: false,
        eventLimit: true, // allow "more" link when too many events
        // contentHeight: document.body.offsetHeight - 190,
        contentHeight: 800,
        // timeFormat: ,
        unselectAuto: false, // 设置当点击页面其他地方的时候，是否清除已选择的区域，值为布尔类型
        // columnFormat: '',
        dragRevertDuration: '1000',
        loading: (isLoading, view) => {
          // isLoading=false时为加载完成,true是正在加载
          // 添加时间选择
          if (
            $('.calendar_box .el-date-editor.el-date-editor--date').find(
              '.replace_title'
            ).length == 0
          ) {
            $('.calendar_box .el-input__inner').after(
              '<p class="replace_title"></p>'
            )
          }

          // 整个日历阻止冒泡
          $('.fc-body').on('click', (e) => {
            e.stopPropagation()
          })
          // 显示时间标题
          this.changeCalTitle()
          // 换侧边栏时间
          this.LeftNavDate()
          // isLoading=false时为加载完成,true是正在加载
          if (!isLoading) {
            var time = view.calendar.currentDate._d
            this.dateTitle =
              `${time.getFullYear()
              }-${
              Outil.timeFormat(time.getMonth() + 1)
              }-${
              Outil.timeFormat(time.getDate())}`
            // 监听切换月周日历视图
            $('.fc-button-group button').on('click', () => {
              this.viewType = $('#calendar').fullCalendar('getView').name
              if (this.viewType == 'month') {
                clearTimeout(this.setTime)
              }
              if (this.displayType) {
                if (this.viewType != 'month') {
                  $('.fc-view-container .fc-view .fc-body').hide()
                  $('.fc-axis').hide()
                }
              } else {
                if (this.viewType != 'month') {
                  $('.fc-view-container .fc-view .fc-body').show()
                  $('.fc-axis').show()
                }
              }

              this.LeftNavDate()
              this.changeCalTitle()
              // 删除月视图的日期
              this.DeleteMonthDate()
              // 阻止冒泡
              $('.fc-body').on('click', (e) => {
                e.stopPropagation()
              })
              this.getBookingEventAccodT()
              // 添加DR图标
              this.AddDRicon()
              this.initScroll()
              this.registerDrag()
            })
          }
          // 添加下划线
          $('.cal_date_opt .el-input__inner').on('mouseenter', () => {
            $('.replace_title').css('text-decoration', 'underline')
          })
          $('.cal_date_opt .el-input__inner').on('mouseleave', () => {
            $('.replace_title').css('text-decoration', 'none')
          })
        },
        viewRender: (view, element) => {
          // 渲染视图后
          const Timetype = $('#calendar').fullCalendar('getView').name
          this.LeftNavDate()
          this.dayForm.WeekSwitch = Timetype == 'agendaWeek'
          // 更新表格标题
          var title = $('.fc-toolbar .fc-center h2').html()
          $('.cal-header .cal-date').html(title)
          // 更新模式选择
          var lis = $('.cal-type li')
          lis.map((item, idx) => {
            if ($(item).attr('data-type') === view.type) {
              $(item).addClass('active').siblings('li').removeClass('active')
            }
            return 1
          })
          if (this.CloneDisabled.disableButton) {
            $('.fc-day-header').append(
              '<i class="iconfont icon-save"  disabled style="margin-left:10px;vertical-align: middle;font-size:35px;font-weight: 400;"></i> <i class="iconfont icon-clear" disabled style="margin-left:5px;vertical-align: middle;font-size:17px;font-weight: 400;"></i>'
            )
          } else {
            $('.fc-day-header').append(
              '<i class="iconfont icon-save"  style="margin-left:10px;vertical-align: middle;font-size:35px;font-weight: 400;"></i> <i class="iconfont icon-clear" style="margin-left:5px;vertical-align: middle;font-size:17px;font-weight: 400;"></i>'
            )
          }

          $('.fc-day-header .icon-save').on('click', (e) => {
            if (this.CloneDisabled.disableButton) return
            scheduleAnalyze('schedulerTabelSaveTemplate', '/po')
            this.daySaveVisible = true
            this.dayForm.name = ''
            this.dayForm.type = 2
            this.dayTime = $(e.target).parent().attr('data-date').replace(/-/g, '/')
          })
          $('.fc-day-header .icon-clear').on('click', (e) => {
            if (this.CloneDisabled.disableButton) return
            scheduleAnalyze('schedulerTabelDeleteTemplate', '/po')
            const dayTime = $(e.target).parent().attr('data-date').replace(/-/g, '/')
            this.$confirm('Are you sure you want to delete all the events of this day?', '', {
              confirmButtonText: this.$t('lang.Confirm'),
              cancelButtonText: this.$t('lang.cancel'),
              type: ''
            }).then(() => {
              this.DeleteDayEvent(dayTime)
            }).catch(() => {
              // 取消操作
            })
          })
          $('.fc-day-header a').on('click', (e) => {
            if (this.displayType) {
              setTimeout(() => {
                this.$nextTick(() => {
                  this.viewType = $('#calendar').fullCalendar('getView').name
                  $('.fc-view-container .fc-view .fc-body').hide()
                  $('.fc-axis').hide()
                  this.getBookingEventAccodT()
                })
              }, 0)
            } else {
              $('.fc-view-container .fc-view .fc-body').show()
              $('.fc-axis').show()
            }
          })
        },
        eventClick: (event, jsEvent, view) => {
          // event点击的事件
          // jsEvent点击的元素
          // 编辑
          this.isShow.edit = true
          // 点击哪个的dom元素
          this.jsEventObj = jsEvent.currentTarget

          this.eventFrom = ''
          // 点击图标
          if (this.IsClickIcon) {
            this.IsClickIcon = false
          }
          // 获取是否ctrl加点击
          const CtrlDown = this.IsSelectedCancel(event)
          if (CtrlDown) return

          this.fillCreateBox(event)
        },
        // 点击选择时间去创建事件,选中日历格事件
        select: (start, end, event, view, resource) => {
          // var id = new Date().getTime();
          let UTCStartTime = Outil.getUTCTime(start._d)
          let UTCEndTime = Outil.getUTCTime(end._d)
          let DSTType = 0
          // 冬夏令时点击空白处显示时间问题
          if (start._i.length == 7 && end._i.length == 7) {
            UTCStartTime = new Date(start._i[0], start._i[1], start._i[2], start._i[3], start._i[4], start._i[5], start._i[6]).getTime()
            UTCEndTime = new Date(end._i[0], end._i[1], end._i[2], end._i[3], end._i[4], end._i[5], end._i[6]).getTime()
            const ComparedStartTime = new Date(start._i[0], start._i[1], start._i[2], start._i[3] + 1, start._i[4], start._i[5], start._i[6]).getTime()
            if (this.DstTime.isDst && UTCStartTime == ComparedStartTime) {
              DSTType = 1
            }
          }
          UTCStartTime = this.getRenderingTime('+', UTCStartTime, DSTType)
          UTCEndTime = this.getRenderingTime('+', UTCEndTime, DSTType)
          // 获取当前点击格子中的最后一个事件
          const preEvent = this.getPreEvent(UTCStartTime, UTCEndTime)
          if (preEvent) {
            const differ = UTCEndTime - UTCStartTime
            UTCStartTime = preEvent.endTime
            UTCEndTime = UTCStartTime + differ
          }
          // 点击空白处创建
          this.ClickandDragCreate({
            startTime: new Date(UTCStartTime),
            endTime: new Date(UTCEndTime)
          }, event, 0)
          // 换时间上显示的时间
          const Showstart = this.transitionHourly(new Date(UTCStartTime))
          const Showstop = this.transitionHourly(new Date(UTCEndTime), 'end')
          $('a.fc-time-grid-event.fc-event.fc-helper').addClass('antline')
          $('a.fc-time-grid-event.fc-event.fc-helper .fc-time span').html(`${Showstart} - ${Showstop}`)
          scheduleAnalyze('schedulerCalendarCreateBoxOpen', '/po')
        },
        selectAllow: (selectInfo) => {
          // 自定义可选取范围
          var date = selectInfo.start._d
          // var UTCStartTime = date.getTime() + date.getTimezoneOffset() * 60000;
          var UTCStartTime = Outil.getUTCTime(date)
          if (UTCStartTime < new Date()) {
            if (this.EventMotion.switch) {
              // 不取消上次选中时间
              $('#calendar').fullCalendar(
                'select',
                this.startDate,
                this.endDate
              )
            }
            return false
          } else {
            return true
          }
        },
        dayClick: (event, jsEvent, view) => {
          jsEvent.stopPropagation()
          this.selected = event
        },
        // 拖动开始前
        eventDragStart: (event, jsEvent, ui, view) => {
          this.eventDragAgain = event.id == this.dragEvent.id
          $('#calendar').fullCalendar('unselect')
          this.initEventData()
        },
        // 拖动停止触发
        eventDragStop: (event, jsEvent, ui, view) => {
          if (this.eventDragAgain) {
            return true
          }
          // 重复拖拽时去掉上一个
          if (this.dragEvent.id) {
            $('#calendar').fullCalendar('removeEvents', this.dragEvent.id)
            // 初始化数据
            this.initEventData()
          }
          if (this.dragEvent.id && event.id != this.dragEvent.id) {
            // 拖动后再去拖另一个事件，还原上次拖动的事件
            let lastEvent
            for (let i = 0; i < this.events.length; i++) {
              if (this.events[i].id == this.dragEvent.id) {
                lastEvent = this.events[i]
                break
              }
            }
            $('#calendar').fullCalendar('renderEvent', lastEvent, true)
          }
          const UTCStartTime = this.getRenderingTime('+', event.start._d.getTime())
          const UTCEndTime = this.getRenderingTime('+', event.end._d.getTime())
          this.dragEvent = {
            id: `${event.id}`,
            start: UTCStartTime,
            end: UTCEndTime
          } // 记录拖动的目标事件
        },
        // 拖动到位置后停止触发
        eventDrop: (
          event,
          dayDelta,
          minuteDelta,
          jsEvent,
          revertFunc,
          allDay,
          ui,
          view
        ) => {
          console.log(event, jsEvent)
          // event时间有问题所以要计算一下
          // 计算拖动之后所在模块的时间
          let startTime = new Date(
            this.dragEvent.start + dayDelta._milliseconds + dayDelta._days * 24 * 60 * 60 * 1000
          )
          let stopTime = new Date(
            this.dragEvent.end +
            dayDelta._milliseconds +
            dayDelta._days * 24 * 60 * 60 * 1000
          )
          if (startTime.getTime() < new Date().getTime()) {
            // 拖拽到已经过去的时间时去掉这个事件
            if (this.dragEvent.id) {
              $('#calendar').fullCalendar('removeEvents')
              $('#calendar').fullCalendar('renderEvents', this.events, true)
              // 初始化数据
              // this.initEventData();
            }
            return
          }
          const startTimeGrid = startTime.getTime()
          const endTimeGrid = stopTime.getTime()
          const HalfHourRange = this.getHalfHourRange(startTimeGrid)
          const durationEvent = endTimeGrid - startTimeGrid
          // 获取当前点击格子中的最后一个事件
          const preEvent = this.getPreEvent(HalfHourRange.startTime, HalfHourRange.endTime)
          if (preEvent) {
            startTime = new Date(preEvent.endTime)
            stopTime = new Date(preEvent.endTime + durationEvent)
          } else {
            startTime = new Date(HalfHourRange.startTime)
            stopTime = new Date(HalfHourRange.startTime + durationEvent)
          }
          $('#calendar').fullCalendar('removeEvents')
          $('#calendar').fullCalendar('renderEvents', this.events, true)
          this.dragEvent.start = startTime.getTime()
          this.dragEvent.end = stopTime.getTime()
          const eventObj = event
          eventObj.start._d = startTime
          eventObj.end._d = stopTime
          // 换时间上显示的时间
          const start = this.transitionHourly(startTime)
          const stop = this.transitionHourly(stopTime, 'end')
          this.jsEventObj = $(`a.fc-event.fc-draggable.${event.id}`)
          const title = event.item.title
          $(`a.fc-event.fc-draggable.${event.id} .fc-title`).html(
            `${start} - ${stop} ${title}`
          )
          setTimeout(() => {
            this.$nextTick(() => {
              // 添加DR图标
              this.AddDRicon()
            })
            this.fillCreateBox(eventObj, jsEvent, 1)
          }, 100)
          if (event.startTime <= new Date().getTime()) {
            // 如果事件已经开始执行，禁止拖动
            this.closeCreateBox()
          }
        }
      },
      selected: {},
      sourcePar: {
        // 获取源列表的参数
        condition: '',
        bookmardIds: 'all',
        unClassified: true,
        pack: true,
        anywhere: true,
        gridPack: true,
        gridSdi: true,
        ext: true,
        token: true,
        scte: true,
        pageNum: 1,
        pageSize: 35
      },
      // sourceId: '',
      sourceList: [], // 源列表
      totalPage: {
        // 设备的总页数
        source: 1,
        r: 1
      },
      lastCondition: {
        // 最后一次搜索的条件
        source: '',
        r: ''
      },
      rPar: {
        // 获取R列表的参数
        condition: '',
        tpeerId: '',
        bookmardIds: 'all',
        unClassified: true,
        pageNum: 1,
        pageSize: 35
      },
      selRName: '',
      lastLeftRPageNum: 1,
      // lastrightRPageNum: 1,
      lastSourcePageNum: 1,
      // rList: [],
      chooseSIndex: 0, // 选中的源下标
      // chooseRIndex: null,     // 选中的R下标
      creating: false, // 正在创建的左头部Booking信息
      creatingObj: {
        // 创建中的booking信息
        source: '',
        r: '',
        time: ''
      },
      isShow: {
        showColorOpt: false,
        createBox: false,
        note: true,
        showHeight: false,
        createBoxSourceList: false,
        bookmark: true,
        edit: true,
        editDelay: false,
        editBit: false,
        deleteBtn: true,
        rList: true,
        sourceList: true,
        create: true
      },
      isCopy: false,
      curLiveStatus: null,
      sourceType: '',
      disable: {
        input: false
      },
      selectR: {},
      selectSource: {},
      magnifyingBtns: 48,
      selColor: {
        name: 'yellow',
        value: 'rgb(255, 192, 0)'
      },
      // addFlag: true,
      createSourceList: [], // 创建框中的R列表
      jsEventObj: '',
      bookmarkArr: [],
      selBookmarkLength: this.bookmark.length,
      curEventCountDown: null,
      eventDetail: {
        // 点击booking后的展示框内数据
        title: '',
        time: '',
        reporter: '',
        description: '',
        source: '',
        r: ''
      },
      heavyLoadObj: {
        active: {
          delay: false,
          bitrate: false
        }
      },
      oldMediaInfo: {},
      // 侧边事件列表
      timeArr: JSON.parse(JSON.stringify(TimetableSideConfig)),
      // 选择当天的时间段
      TimeQuantum: 0,
      // 时间格式
      TimeFormat: 0,
      // 点击跳转的事件的ID
      activeId: '',
      // 判断是list模式还是日历模式
      displayType: 0,
      // 周视图数据
      eventModesList: [],
      // 每天头部的宽度
      headWith: 0,
      // 日视图数据
      eventDayList: [],
      // 试图类型
      viewType: '',
      TimeQuantumStart: 0,
      // 当天时间段的开始时间
      curDate: 0,
      // 头部时间集合
      aheadTimeArr: [],
      setTime: null,
      // 强制填充选择框数据
      forceFillMessage: {
        show: false
      },
      // 拖拽模板时间选择
      SchedulerDragTime: {
        show: false
      },
      // 间隙数据
      GapTime: {},
      // 创建event初始数据
      form: {},
      // 是否取整
      MediaIsRound: false,
      // 增加提示是否取整
      MediaTimeFloor: {
        show: false,
        type: 'single', // 类型是多文件还是单文件
        createEvent: {}, // 单文件创建信息
        ListStartTime: {} // 多文件创建的开始时间,

      },
      mode: {
        0: '',
        1: 'HLD/MAN',
        2: 'EXT'
      }
    }
  },
  created () {
    this.createStartTime = new Date()
    this.createStopTime = new Date()
    this.handleResize()
    Outil.heavyLoad(this.heavyLoadObj, 'change', 2, this.changeActiveStatus, this)
    Bus.$on('updateEventList', () => {
      this.getBookingEventAccodT()
    })
    Bus.$on('langSeltSwitch', (val) => {
      if (!this.$i18n) return
      this.calendarConfig.buttonText = {
        today: this.$t('lang.todayKey'),
        month: this.$t('lang.monthKey'),
        week: this.$t('lang.weekKey'),
        day: this.$t('lang.dayKey')
      }
      this.calendarFlag = false
      this.handleResize()
      this.$nextTick(() => {
        this.calendarFlag = true
        this.getBookingEventAccodT()
      })
    })
    Bus.$on('leftListUpdate', this.registerDrag)
    Bus.$on('changeSource', (sourceObj) => {
      if (sourceObj.type.toLowerCase() == 'scte') return
      this.selectSource = sourceObj
    })
    // 点击事件搜索出的结果跳转到对应事件并添加边框
    Bus.$on('clickSearchResult', async (item) => {
      if (item.hours < this.TimeQuantum) {
        this.dateTitle = item.nowDate.split(' ')[0]
      } else {
        this.dateTitle = item.startTime.split(' ')[0]
      }
      await this.changeDateView(this.dateTitle)
      this.changeCalTitle()
      this.handleScroll($(`.${item.id}`)[0])
      if (item.id == this.activeId) {
        $(`.${item.id}`).css('border', '4px solid #FFF510')
      } else {
        $(`.${item.id}`).css('border', '4px solid #FFF510')
        if (this.activeId) {
          $(`.${this.activeId}`).css('border', 'none')
        }
      }
      this.activeId = item.id
    })
    // 切换list模式和日历模式
    Bus.$on('changeSchedulerModes', (type) => {
      if (type == 'calendar') {
        this.displayType = 0
        $('.fc-view-container .fc-view .fc-body').show()
        $('.fc-axis').show()
        // $('.fc-button-group  .fc-month-button').show()
        $('.calendar_box').removeClass('calendar_list')
        this.getBookingEventAccodT()
      } else {
        this.displayType = 1
        this.viewType = $('#calendar').fullCalendar('getView').name
        if (this.viewType != 'month') {
          $('.fc-view-container .fc-view .fc-body').hide()
          $('.fc-axis').hide()
        }
        // $('.fc-button-group  .fc-month-button').hide()
        $('.calendar_box').addClass('calendar_list')
        this.$nextTick(() => {
          this.headWith = $('.fc-day-header').width()
        })
        this.getBookingEventAccodT()
        // this.$nextTick(() => {

        // })
        this.registerDrag()
      }
    })
    // 获取夏令时以及一天时间段
    this.getDstandTimeQuantum()
    // 获取时区
    const homeTimeZone = Outil.getProgramReceiver('homeTimeZone')
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    this.homeTimeZone = homeTimeZone || timeZone
    const today = new Date()
    // 获取当天时间段的开始时间
    if (today.getHours() >= this.TimeQuantum) {
      this.curDate = new Date(`${today.getFullYear()}/${today.getMonth() + 1}/${today.getDate()} ${this.TimeQuantum}:0:0`)
      this.TimeQuantumStart = new Date(`${today.getFullYear()}/${today.getMonth() + 1}/${today.getDate()} ${this.TimeQuantum}:0:0`)
    } else {
      const Millisecond = new Date(`${today.getFullYear()}/${today.getMonth() + 1}/${today.getDate()} 0:0:0`).getTime() - 60 * 60 * 1000
      const currentDay = new Date(Millisecond)
      this.curDate = new Date(`${currentDay.getFullYear()}/${currentDay.getMonth() + 1}/${currentDay.getDate()} ${this.TimeQuantum}:0:0`)
      this.TimeQuantumStart = new Date(`${currentDay.getFullYear()}/${currentDay.getMonth() + 1}/${currentDay.getDate()} ${this.TimeQuantum}:0:0`)
    }
  },
  mounted () {
    // document.body.addEventListener('click', '#calendar .fc-toolbar.fc-header-toolbar')
    $('body').on('click', '#calendar .fc-toolbar.fc-header-toolbar', () => {
      this.closeCreateBox()
    })
    this.MonitorMouseButton()
    this.WebpageHeightChange()
    // 获取media是否取整
    commonRequest.getMediaIsRound().then((res) => {
      this.MediaIsRound = res
    })
    // 跳转指定事件
    Bus.$on('jumpDesignatedEvent', async (item) => {
      if (item.hours < this.TimeQuantum) {
        this.dateTitle = item.beforeDay.split(' ')[0]
      } else {
        this.dateTitle = item.Day.split(' ')[0]
      }
      await this.changeDateView(this.dateTitle)
      this.changeCalTitle()
      this.handleScroll($(`.${item.id}`)[0])
    })
  },
  watch: {
    'dateInfo.show' (val) {
      this.$nextTick(() => {
        if (!val) {
          this.dragToCreateEvent()
        }
      })
    },
    // 行为同步
    '$store.state.BehaviorChange' (data) {
      console.log('sc-calendar')
      if (typeof data != 'object') return
      if (data.action == 'EventListChange' || (data.action == 'playoutPreviewStatusModule' && data.isRefreshPlayList)) {
        this.getBookingEventAccodT(true)
      }
    },
    AdvancedSetupConfig: {
      handler (item) {
        this.displayEventMetadata = item.displayEventMetadata ? item.displayEventMetadata.split(',') : []
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations('playout', ['setCtrlCopyEvent']),
    // 监听屏幕高度变化
    WebpageHeightChange () {
      this.controlCalendarHeight('init')
      window.addEventListener('resize', this.controlCalendarHeight)
    },
    // 控制视频宽度变化
    controlCalendarHeight (type) {
      const ContentCalendarBox = document.getElementById('ContentCalendarBox')
      if (!ContentCalendarBox) {
        return
      }
      const docHeight = document.getElementById('ContentCalendarBox').offsetHeight
      const contentHeight = docHeight || 0
      const Difference = Math.abs(this.calendarConfig.contentHeight - contentHeight)
      if (type == 'init') {
        this.calendarFlag = true
        this.calendarConfig.contentHeight = docHeight - 50
      } else {
        if (this.displayType) {
          return
        }
        if (Difference > 10) {
          // 获取当前视图与时间
          const viewType = $('#calendar').fullCalendar('getView').name
          let getCurrenTime = new Date()
          if (viewType == 'agendaWeek' || viewType == 'agendaDay') {
            const TimeList = this.getCurrenTime()
            getCurrenTime = TimeList[0]
          } else {
            getCurrenTime = $('.fc-center h2').html()
          }
          const CurrenTime = new Date(getCurrenTime)
          this.calendarFlag = false
          this.calendarConfig.defaultView = viewType
          this.calendarConfig.contentHeight = docHeight - 50
          this.$nextTick(() => {
            this.calendarFlag = true
            this.$nextTick(() => {
              $('#calendar').fullCalendar('gotoDate', CurrenTime)
              $('#calendar').fullCalendar('removeEvents')
              $('#calendar').fullCalendar('renderEvents', this.events, true)
              // 滚动到指定位置
              $('.fc-scroller.fc-time-grid-container').scrollTop(this.RecordScrollHeight)
              this.$nextTick(() => {
                // 添加DR图标
                this.AddDRicon()
                this.registerDrag()
              })
            })
          })
        }
      }
    },
    // 获取拖拽事件时间所在半个小时
    getHalfHourRange (timestamp) {
      const date = new Date(timestamp)
      const hours = date.getHours()
      const minutes = date.getMinutes()
      const roundedMinutes = Math.floor(minutes / 30) * 30 // 取整到最近的半小时
      const dateStr = Outil.changeNewDate(timestamp)
      const start = `${dateStr} ${hours}:${roundedMinutes}`
      const startTime = new Date(start).getTime() // 半小时范围的起始时间
      const endTime = startTime + 30 * 60 * 1000// 半小时范围的结束时间（起始时间加上30分钟）
      return {
        startTime,
        endTime
      }
    },
    // 获取第二天的时间
    getNextDate (index, time) {
      let nextDateTime
      if (time) {
        nextDateTime = Outil.changeNewDate(time + 25 * 60 * 60 * 1000)
      } else {
        nextDateTime = Outil.changeNewDate(this.aheadTimeArr[index] + 25 * 60 * 60 * 1000)
      }
      const nextTime = new Date(`${nextDateTime} ${this.TimeQuantum}:00:00`).getTime()
      return nextTime
    },
    // 获取渲染时间
    getRenderingTime (type, timestamp, DSTType) {
      const time = new Date(timestamp)
      let date = Outil.changeNewDate(timestamp, 1)
      // 零点时间
      const ZeroTime = new Date(date).getTime()
      let hour = time.getHours()
      if (DSTType) {
        hour = hour - 1
      }
      const min = time.getMinutes()
      const s = time.getSeconds()
      if (type == '+') {
        hour = hour + this.TimeQuantum
      } else if (type == '-') {
        hour = hour - this.TimeQuantum
      }
      if (hour < 0) {
        date = Outil.changeNewDate(ZeroTime - 60 * 60 * 1000, 1)
        hour = hour + 24
      } else if (hour > 23) {
        date = Outil.changeNewDate(ZeroTime + 25 * 60 * 60 * 1000, 1)
        hour = hour - 24
      }
      const RenderingTime = new Date(`${date} ${hour}:${min}:${s}`).getTime()
      return RenderingTime
    },
    // 处理周视图数据
    dealEventModesList () {
      this.eventModesList = this.eventModesList.map((v, index) => {
        // 过滤周视图超过当天的数据
        v = v.filter((item, i) => {
          return item.startTime < this.getNextDate(index)
        })
        // 处理冬令时数据
        // v = v.map((item, i) => {
        //   return this.dealWinterTime(item, i, v, index)
        // })
        // // 过滤冬令时的重复数据
        // v = v.filter((item, i) => {
        //   return item
        // })
        v = v.map((item, i) => {
          return this.dealAllData(item, i, v, index)
        })
        // v = v.filter((item, i) => {
        //   return item
        // })
        return v
      })
    },
    // 处理日视图数据
    dealEventDayList (time) {
      // 过滤日视图超过当天的数据
      this.eventDayList = this.eventDayList.filter((v, i) => {
        return v.startTime < this.getNextDate(0, time)
      })
      // 处理冬令时数据
      // this.eventDayList = this.eventDayList.map((item, i) => {
      //   return this.dealWinterTime(item, i, null, null, time)
      // })
      // // 过滤冬令时的重复数据
      // this.eventDayList = this.eventDayList.filter((v, i) => {
      //   return v
      // })
      this.eventDayList = this.eventDayList.map((item, i) => {
        return this.dealAllData(item, i, null, null, time)
      })
    },
    dealWinterTime (item, i, v, index, time) {
      // 判断夏令时 0 正常, 1 第二个小时, 2 跨过两个
      let isDst = false
      if (this.DstTime.isDst) {
        // 修改夏令时事件的样式
        if ((item.startTime >= this.DstTime.secondDstDate.lastHour && item.startTime < this.DstTime.secondDstDate.startTime) && (item.endTime >= this.DstTime.secondDstDate.startTime && item.endTime < this.DstTime.secondDstDate.endTime)) {
          isDst = 2
        }
        if ((item.startTime >= this.DstTime.secondDstDate.startTime && item.startTime < this.DstTime.secondDstDate.endTime) && (item.endTime > this.DstTime.secondDstDate.startTime && item.endTime <= this.DstTime.secondDstDate.endTime)) {
          isDst = 1
        }
      }
      if (isDst == 2 || isDst == 1) {
        if (isDst == 1) return
        // 遇到冬令时跨越两个小时，显示时间转换
        const eventInfoStart = JSON.parse(JSON.stringify(item))
        const ShowStart = this.getRenderingTime('-', item.startTime)
        const ShowEnd = this.getRenderingTime('-', this.DstTime.secondDstDate.startTime - 1)
        eventInfoStart.start = $.fullCalendar.moment(ShowStart)
        eventInfoStart.end = $.fullCalendar.moment(ShowEnd)
        return { ...eventInfoStart }
      } else {
        return { ...item }
      }
    },
    // 处理list模式数据
    dealAllData (item, i, v, index, time) {
      const parameters = item.parameters
        ? JSON.parse(item.parameters)
        : {}
      // item.source = item.source ? JSON.parse(JSON.stringify(item.source)) : {}
      let bgColor = item.color || 'rgb(255, 192, 0)'
      const eventData = {
        description: item.description || '',
        reporter: parameters.reporter || '',
        title: item.title,
        tname: item.tname,
        rname: item.rname,
        tpeerid: item.tpeerid,
        rpeerid: item.rpeerid,
        type: item.ttype,
        delay: parameters.delay || '',
        bitrate: parameters.bitrate || '',
        url: (item.source && item.source.url) || '',
        // spliceType: item.scte ? item.scte.spliceType : '',
        duration: item.scte ? item.scte.duration : '',
        videoTimes: ['file', 'video'].includes(item.ttype.toLowerCase())
          ? (item.endTime - item.startTime) / 1000
          : '',
        prerollTime: item.scte ? item.scte.prerollTime : '',
        email: item.email,
        userId: item.userId
      }
      const colorName = this.mateColor(bgColor)
      if (item.liveStatus == 1) {
        // 正在执行的事件为green
        bgColor = 'rgb(15, 190, 113)'
        // item.color = 'rgb(15, 190, 113)'
      }
      if (item.liveStatus == 2 || (item.liveStatus == 4 && (item.failedReason == 'Take Next'))) {
        bgColor = '#777777'
        // item.color = '#777777'
      }
      if ((item.liveStatus == 4 && (item.failedReason != 'Take Next')) || item.liveStatus == 5 || item.liveStatus == 6) {
        bgColor = '#8A4B4B'
        // item.color = '#8A4B4B'
      }
      // // 判断夏令时 0 正常, 1 第二个小时, 2 跨过两个
      let isDst = false
      if (this.DstTime.isDst) {
        // 修改夏令时事件的样式
        if ((item.startTime >= this.DstTime.secondDstDate.lastHour && item.startTime < this.DstTime.secondDstDate.startTime) && (item.endTime >= this.DstTime.secondDstDate.startTime && item.endTime < this.DstTime.secondDstDate.endTime)) {
          isDst = 2
        }
        if ((item.startTime >= this.DstTime.secondDstDate.startTime && item.startTime < this.DstTime.secondDstDate.endTime) && (item.endTime > this.DstTime.secondDstDate.startTime && item.endTime <= this.DstTime.secondDstDate.endTime)) {
          isDst = 1
        }
      }
      const eventInfo = {
        id: item.eventId,
        eventId: item.eventId,
        item,
        eventData,
        backgroundColor: bgColor,
        colorName,
        borderColor: '#FFF510',
        className: `livestatus-${item.liveStatus} ${item.eventId} copy_icon`,
        startTime: item.startTime,
        endTime: item.endTime,
        liveStatus: item.liveStatus,
        email: item.email,
        userId: item.userId,
        copy: item.copy,
        sourceType: item.sourceType,
        eventSegments: item.eventSegments,
        gaptime: 0, // 时间间隙
        isLast: false, // 是否是最后一个
        isShow: false, // 是否展示
        lastTime: 0, // 当天结束时间
        curStartTime: 0, // 当天开始时间
        gapDuration: 0,
        firtIsShow: false,
        preEndTime: 0,
        gapEndTime: this.getNextDate(index, time),
        failedReason: item.failedReason
      }
      let eventDataList, lastTime
      // 如果V存在 说明是周视图 不存在则为日视图
      if (v) {
        eventDataList = v
        eventInfo.lastTime = this.aheadTimeArr[index] + 24 * 60 * 60 * 1000
        eventInfo.curStartTime = this.aheadTimeArr[index]
      } else {
        eventDataList = this.eventDayList
        eventInfo.lastTime = new Date(`${this.getCurrenTime()[0]} ${this.TimeQuantum}:00:00`).getTime() + 24 * 60 * 60 * 1000
        eventInfo.curStartTime = new Date(`${this.getCurrenTime()[0]} ${this.TimeQuantum}:00:00`).getTime()
      }
      if (index > 0) {
        // 拿到上一天和下一天一样的事件
        const someEvent = this.eventModesList[index - 1].filter(v => {
          return v.id == eventDataList[0].id
        })
        // 如果拿不到 说明没有跨天的事件

        if (someEvent.length) {
          const someIndex = this.eventModesList[index - 1].indexOf(someEvent[0])
          if (someIndex != -1) {
            // const someEndTime = this.eventModesList[index - 1][someIndex - 1].endTime

            // if (someEndTime == eventDataList[0].startTime) {
            //   eventInfo.firtIsShow = false
            // } else {
            //   eventInfo.preEndTime = someEndTime
            //   eventInfo.firtIsShow = true
            // }
          }
        } else {
          eventInfo.firtIsShow = true
        }
      }
      if (i + 1 == eventDataList.length) {
        eventInfo.gaptime = 0
        eventInfo.isLast = true
      } else {
        if (eventDataList[i + 1].startTime - item.endTime) {
          if ((eventDataList[i + 1].startTime - item.endTime) < 1000) {
            eventInfo.gaptime = 0
          } else {
            eventInfo.gaptime = Outil.getDuration(eventDataList[i + 1].startTime - item.endTime)
          }
          eventInfo.gapDuration = eventDataList[i + 1].startTime - item.endTime
          if (eventDataList[i + 1].startTime <= new Date().getTime()) {
            eventInfo.isShow = false
          } else {
            eventInfo.isShow = true
          }
        } else {
          eventInfo.gaptime = 0
          eventInfo.isLast = false
        }
      }

      // return eventInfo
      if (isDst == 2 || isDst == 1) {
        // if (isDst == 1) return
        // 遇到冬令时跨越两个小时，显示时间转换
        const eventInfoStart = JSON.parse(JSON.stringify(eventInfo))
        const ShowStart = this.getRenderingTime('-', item.startTime)
        const ShowEnd = this.getRenderingTime('-', this.DstTime.secondDstDate.startTime)
        eventInfoStart.start = $.fullCalendar.moment(ShowStart)
        eventInfoStart.end = $.fullCalendar.moment(ShowEnd)
        return { ...eventInfoStart }
      } else {
        return { ...eventInfo }
      }
    },
    // 点击+号创建
    createEvent (param) {
      if (param[2] == 1) {
        this.ClickandDragCreate(param[0], param[1], 0)
      } else if (param[2] == 2) {
        // const nowStartTime = this.TimeQuantumStart.getTime()
        // const changedStartTime = new Date(`${this.getCurrenTime()[param[3]]} ${this.TimeQuantum}:00:00`).getTime()
        const eventObj = {
          startTime: '',
          endTime: ''
        }
        // let nowTime
        // if (nowStartTime == changedStartTime) {
        //   nowTime = new Date().getTime() + 3 * 60 * 1000
        //   eventObj.startTime = nowTime
        //   eventObj.endTime = nowTime + 30 * 60 * 1000
        // } else {
        // // nowTime = new Date().getTime() + 3 * 60 * 1000
        // // const nowGapTime = nowTime - nowStartTime
        //   eventObj.startTime = param[0].endTime
        //   eventObj.endTime = param[0].endTime + 30 * 60 * 1000
        // }
        if (param[0].endTime > new Date().getTime()) {
          eventObj.startTime = param[0].endTime
          eventObj.endTime = param[0].endTime + 30 * 60 * 1000
        } else {
          eventObj.startTime = new Date().getTime() + 3 * 60 * 1000
          eventObj.endTime = new Date().getTime() + 33 * 60 * 1000
        }
        eventObj.startTime = new Date(eventObj.startTime)
        eventObj.endTime = new Date(eventObj.endTime)
        this.ClickandDragCreate(eventObj, param[1], 0)
      } else if (param[2] == 3) {
        let eventObj
        if (this.viewType == 'agendaDay') {
          const changedStartTime = new Date(`${this.getCurrenTime()[0]} ${this.TimeQuantum}:00:00`).getTime()
          let startTime
          if (new Date().getTime() > changedStartTime || new Date().getTime() == changedStartTime) {
            startTime = new Date().getTime() + 1 * 60 * 1000
          } else {
            startTime = changedStartTime
          }
          eventObj = {
            startTime: startTime,
            endTime: startTime + 30 * 60 * 1000
          }
        } else if (this.viewType == 'agendaWeek') {
          let startTime
          if (new Date().getTime() > this.aheadTimeArr[param[0]] || new Date().getTime() == this.aheadTimeArr[param[0]]) {
            startTime = new Date().getTime() + 1 * 60 * 1000
          } else {
            startTime = this.aheadTimeArr[param[0]]
          }
          eventObj = {
            startTime: startTime,
            endTime: startTime + 30 * 60 * 1000
          }
        }
        eventObj.startTime = new Date(eventObj.startTime)
        eventObj.endTime = new Date(eventObj.endTime)
        this.ClickandDragCreate(eventObj, param[1], 0)
      } else {

      }
    },
    // 滚动到事件位置
    handleScroll (dom) {
      dom.scrollIntoView()
    },
    // 获取夏令时以及一天时间段
    getDstandTimeQuantum () {
      // 获取今年的夏令时时间
      const DstTime = Outil.DisplayDstSwitchDates(new Date().getYear())
      this.DstTime = DstTime
      const ProgramRMessage = Outil.getProgramReceiver()
      const TimeFormat = Outil.getDateTimeFormat()
      this.TimeFormat = TimeFormat.broadcastTimeFormat
      if (ProgramRMessage) {
        this.TimeQuantum = ProgramRMessage.broadcastDay
        const dayTime = this.timeArr.splice(0, this.TimeQuantum)
        this.timeArr.push(...dayTime)
      }
    },
    // 判断是什么操作系统
    JudgeOperating () {
      const isMac = /macintosh|mac os x/i.test(navigator.userAgent)
      if (isMac) {
        return true
      } else {
        return false
      }
    },
    // 清除一周事件
    ClearWeekEvent () {
      if (this.CloneDisabled.disableButton) return
      this.$confirm(this.$t('lang.ClearWeekHint'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel')
      }).then(() => {
        const WeekTime = this.getCurrenTime()
        const dayStart = this.getRenderingTime('+', new Date(`${WeekTime[0]} 00:00:00`).getTime())
        const dayEnd = this.getRenderingTime('+', new Date(`${WeekTime[6]} 23:59:59`).getTime())
        this.loadingCalendar = true
        this.axios.post('/gatewayPlayoutUrl/tvu-playout/event/deleteEventByTime',
          {
            programId: this.$BehaviorSyns.getProgramId(),
            startTime: dayStart,
            endTime: dayEnd
          }).then((res) => {
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              this.$message({
                type: 'success',
                message: this.$t('lang.success')
              })
              this.getBookingEventAccodT()
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.error(errorInfo)
            }
          }
          this.loadingCalendar = false
        }).catch(() => {
          this.loadingCalendar = false
        })
      }).catch(() => {
        // 取消操作
      })
    },
    // 保存一周模板
    SaveWeekTemplate () {
      if (this.CloneDisabled.disableButton) return
      this.daySaveVisible = true
      this.dayForm.name = ''
      this.dayForm.type = 1
    },
    ClickEvent (event) {
      // 获取是否ctrl加点击
      const CtrlDown = this.IsSelectedCancel(event)
      if (CtrlDown) return

      this.fillCreateBox(event)
    },
    // 监听键盘以及鼠标事件
    MonitorMouseButton () {
      this.$nextTick(() => {
        this.isMac = this.JudgeOperating()
        document.addEventListener('keydown', this.Onkeydown)
        document.getElementById('listenRightClick').addEventListener('contextmenu', this.OnRightClick)
        // 监听松开鼠标
        document.addEventListener('mouseup', this.OnLeftClick)
      })
    },
    // 监听键盘按下
    Onkeydown (e) {
      if (e.ctrlKey === true && e.keyCode == 67) {
        if (this.PitchEventList.length > 0) {
          this.setCtrlCopyEvent(this.PitchEventList)
          // 清除
          this.ClearMultiple()
        }
      }
    },
    // 计算位置
    CalculatePosition (e) {
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight
      const distanceFromRight = windowWidth - e.clientX
      const distanceFromBottom = windowHeight - e.clientY
      const left = distanceFromRight < 120 ? e.clientX - 100 : e.clientX
      const top = distanceFromBottom < 100 ? e.clientY - 100 : e.clientY
      return {
        left: `${left}px`,
        top: `${top}px`
      }
    },
    // 监听鼠标右击
    OnRightClick (e) {
      // 鼠标右键点击
      // e.button == 2 || (e.button == 0 && this.MACCtrl)
      if (e.button == 2) {
        // 选中右击
        if (this.PitchEventList.length > 0) {
          e.preventDefault()
          const style = this.CalculatePosition(e)
          this.OperationStyle = {
            style,
            Switch: true,
            type: 0
          }
        } else if (this.CtrlCopyEvent && this.CtrlCopyEvent.length > 0) {
          // ctrl+c 右击
          // 获取当前右键点击的元素
          const targetElement = e.target
          // 找到具有data-id属性的祖先元素
          const parentElement = targetElement.closest('[data-id]')
          // 右击在事件上
          if (parentElement) {
            // 获取到data-id属性的值
            const dataId = parentElement.dataset.id
            // 根据需要进行后续处理
            e.preventDefault()
            const style = this.CalculatePosition(e)
            this.OperationStyle = {
              style,
              Switch: true,
              type: 1,
              event: true,
              dataId
            }
            // 右击在时间上
          } else {
            const view = $('#calendar').fullCalendar('getView')
            let startTime
            if (this.displayType == 1) {
              const ListMode = this.getListModeClickTime(e, view)
              startTime = ListMode.startTime
            } else {
              const EventMode = this.getEventModeClickTime(e, view)
              startTime = EventMode.startDate
            }
            e.preventDefault()
            const style = this.CalculatePosition(e)
            this.OperationStyle = {
              style,
              Switch: true,
              type: 1,
              event: false,
              startTime
            }
          }
        }
      }
    },
    // 监听左击
    OnLeftClick (e) {
      // 鼠标左键点击
      if (e.button == 0) {
        // 是否是对选中的事件进行操作
        if (e.target.dataset && e.target.dataset.id === 'MouseRightClick') return
        // Ctrl,shift还在按着
        if (e.ctrlKey || e.metaKey || e.shiftKey) return
        // 如果没有选中并且没有右击则不执行
        if (this.PitchEventList.length == 0 && !this.OperationStyle.Switch) return
        setTimeout(() => {
          // 正在移动copy删除
          if (this.MoveandCopyTime.show) return
          // 清除
          this.ClearMultiple()
        }, 100)
      }
    },
    // 判断是选中还是取消
    IsSelectedCancel (PitchItem) {
      const PitchEvent = PitchItem.item ? PitchItem.item : PitchItem
      const e = window.event || {}
      if (e.shiftKey) {
        if (this.ShiftClickData.id) {
          this.ShiftMultipleEvent(PitchEvent)
        } else {
          this.CtrlClickMouse(PitchEvent, e)
        }
        return true
      } else if (e.ctrlKey || e.metaKey) {
        // 点击时是否按住ctrl
        this.CtrlClickMouse(PitchEvent, e)
        return true
      } else {
        this.ClearMultiple()
        return false
      }
    },
    // shift多选事件
    ShiftMultipleEvent (PitchEvent) {
      // 时间排序
      const PageAllEvent = [...this.PageAllEvent].sort((a, b) => a.startTime - b.startTime)
      let firstEvent = false
      let secondEvent = false
      this.ClearMultiple('list')
      PageAllEvent.forEach((item) => {
        // 判断顺序不可变
        if (firstEvent && secondEvent) return
        if (this.ShiftClickData.id === item.id) {
          firstEvent = true
        }
        if (PitchEvent.id === item.id) {
          secondEvent = true
        }
        if (firstEvent || secondEvent) {
          let parentElement = null
          if (this.displayType) {
            parentElement = document.querySelector(`.dayList .a${item.id}`)
          } else {
            parentElement = document.querySelector(`#calendar .a${item.id}`)
          }
          if (!parentElement) return
          this.PitchEventList.push(item)
          // 获取什么视图
          const Timetype = $('#calendar').fullCalendar('getView').name
          if (Timetype == 'month') {
            parentElement.style.border = 'solid 5px #83ED7C'
            parentElement.style.boxSizing = 'border-box'
            parentElement.style.height = '16px'
            parentElement.style.overflow = 'hidden'
          } else {
            parentElement.style.border = 'solid 5px #83ED7C'
          }
        }
      })
    },
    // ctrl加click选中 点击选中
    CtrlClickMouse (PitchItem, e) {
      if (!PitchItem.id || !e.target) return
      let PitchIndex = null
      this.PitchEventList.forEach((item, index) => {
        if (item.id == PitchItem.id) {
          PitchIndex = index
        }
      })
      const targetElement = e.target
      const parentElement = targetElement.closest(`.a${PitchItem.id}`)
      if (!parentElement) return
      this.ShiftClickData = PitchItem
      if (PitchIndex != null) {
        this.PitchEventList.splice(PitchIndex, 1)
        parentElement.style.border = 'solid 0px transparent'
      } else {
        this.PitchEventList.push(PitchItem)
        // 获取什么视图
        const Timetype = $('#calendar').fullCalendar('getView').name
        if (Timetype == 'month') {
          parentElement.style.border = 'solid 5px #83ED7C'
          parentElement.style.boxSizing = 'border-box'
          parentElement.style.height = '16px'
          parentElement.style.overflow = 'hidden'
        } else {
          parentElement.style.border = 'solid 5px #83ED7C'
        }
      }
    },
    // 清除鼠标点击，以及多选操作
    ClearMultiple (type) {
      this.PitchEventList.forEach((item) => {
        if (this.displayType) {
          document.querySelector(`.dayList .a${item.id}`).style.border = 'solid 0px transparent'
        } else {
          document.querySelector(`#calendar .a${item.id}`).style.border = 'solid 0px transparent'
        }
      })
      this.PitchEventList = []
      this.$set(this.OperationStyle, 'Switch', false)
      if (type !== 'list') {
        this.ShiftClickData = {}
      }
    },
    // 删除多个事件
    DeleteMoreEvent () {
      this.$confirm(this.$t('lang.prompEnsureDel'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        const param = this.multiOperationParam('delete')
        this.axios({
          method: 'post',
          url: Outil.getUrl('/event/delete'),
          data: { ids: param },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              message: this.$t('lang.success'),
              type: 'success'
            })
            // 删除成功后刷新列表
            this.getBookingEventAccodT(true)
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
          this.ClearMultiple()
        }).catch(() => {})
      }).catch(() => {
        // 取消操作
      })
    },
    // CopyandMove事件
    CopyandMoveEvent (value, type, other) {
      if (!value) {
        this.MoveandCopyTime.type = type
        this.MoveandCopyTime.show = true
      } else {
        let url
        if (type == 'Move') {
          url = '/event/moveEvents'
        } else {
          url = '/event/copyEvents'
        }
        const param = {
          programId: this.$BehaviorSyns.getProgramId(),
          eventIds: this.multiOperationParam(type),
          coverEvent: false,
          operationType: 0,
          cancelFirstEventFollowOn: other.FollowOn
        }
        if (type == 'Copy' && other.event) {
          param.operationType = other.event
          param.eventId = other.TimeAndId
        } else {
          param.startTime = other.TimeAndId
        }
        this.loadingCalendar = true
        this.axios({
          method: 'post',
          url: Outil.getUrl(url),
          data: param,
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              message: this.$t('lang.success'),
              type: 'success'
            })
            // 删除成功后刷新列表
            this.getBookingEventAccodT(true)
            this.loadingCalendar = false
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
            this.loadingCalendar = false
          }
          this.ClearMultiple()
        }).catch(() => {
          this.loadingCalendar = false
        })
      }
    },
    // 选择copy，move时间
    ApplyStartFrom (time, ShowFollowOnHint) {
      this.MoveandCopyTime.show = false
      this.CopyandMoveEvent(true, this.MoveandCopyTime.type, {
        FollowOn: ShowFollowOnHint,
        TimeAndId: time
      })
    },
    // delete，copy，move参数转换
    multiOperationParam (type) {
      const paramList = []
      let CopyEventList = []
      if (type == 'Copy') {
        CopyEventList = this.CtrlCopyEvent
      } else {
        CopyEventList = this.PitchEventList
      }
      CopyEventList.forEach((item) => {
        paramList.push(item.id)
      })
      if (type == 'delete') {
        return paramList
      } else {
        return paramList.join(',')
      }
    },
    // 24小时制转12小时制
    transitionHourly (time, TimeType) {
      if (time) {
        let type = ''
        let hour = time.getHours()
        let min = time.getMinutes()
        let s = time.getSeconds()
        // 结束时间是夏令时 修改显示时间
        if (this.DstTime.isDst && TimeType == 'end') {
          if (time.getTime() == this.DstTime.firstDstDate.startTime) {
            hour = hour - 1
          }
        }
        if (this.TimeFormat) {
          hour = hour >= 0 && hour < 10 ? `0${hour}` : hour
        } else {
          if (hour >= 0 && hour <= 11) {
            type = 'AM'
            hour = hour == 0 ? 12 : hour
          } else {
            type = 'PM'
            hour = hour == 12 ? hour : hour - 12
          }
        }
        min = min >= 0 && min < 10 ? `0${min}` : min
        s = s >= 0 && s < 10 ? `0${s}` : s
        return `${hour}:${min}:${s} ${type}`
      }
    },
    // 删除月视图的日期
    DeleteMonthDate () {
      const type = $('#calendar').fullCalendar('getView').name
      if (type == 'month') {
        $('.fc-day-header i').remove()
        const calendarTitle = $('.fc-day-header span')
        calendarTitle.map((index, item) => {
          const title = $(item).text()
          $(item).text(title.split(' ')[0])
          return 1
        })
      }
    },
    // 取消编辑模板
    CancelTemplate () {
      this.IsShowTemplate = 0
      this.getBookingEventAccodT()
      this.registerDrag()
    },
    // 保存当天为模板
    daySaveName () {
      let dayStart = 0
      let dayEnd = 0
      if (this.dayForm.type == 2) {
        dayStart = Date.parse(new Date(`${this.dayTime} ${this.TimeQuantum}:00:00`)) // 2016-12-29 0:0:0
        dayEnd = new Date().setTime((dayStart / 1000 + 24 * 60 * 60 - 1) * 1000)
      } else {
        const WeekTime = this.getCurrenTime()
        dayStart = new Date(`${WeekTime[0]} 00:00:00`).getTime() + this.TimeQuantum * 60 * 60 * 1000
        dayEnd = new Date(`${WeekTime[6]} 23:59:59`).getTime() + this.TimeQuantum * 60 * 60 * 1000
      }
      this.dayForm = {
        name: this.dayForm.name,
        type: 1,
        startTime: dayStart,
        endTime: dayEnd,
        rid: this.currentSelectPeerid,
        scheduleType: this.dayForm.type // 日还是周模板
      }
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/template/saveAsTemplate', this.dayForm).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.daySaveVisible = false
            this.addTemplateSucc = !this.addTemplateSucc
            Bus.$emit('ScheduleTemplateUpdate')
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }
      })
    },
    // 删除一天的事件
    DeleteDayEvent (dayTime) {
      const startTime = new Date(`${dayTime} ${this.TimeQuantum}:00:00`).getTime()
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/event/deleteEventByDay',
        {
          rid: this.selectR.peerId,
          startTime
        }, {
          timeout: 120000
        }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            this.getBookingEventAccodT()
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }
      }).catch(() => {})
    },
    // 判断是哪种模板进入next
    isNext (data) { },
    // 编辑模板
    editTemplate (data) {
      if (data.name == 'programTemplate') {
        if (data.status) this.IsShowTemplate = 2
        if (!data.status && this.IsShowTemplate == 2) this.IsShowTemplate = 0
        // this.$nextTick(() => {
        //   this.IsShowTemplate = 2
        // })
      } else {
        this.IsShowTemplate = 0
        if (data.name == 'scheduleVis') {
          this.TemplateBodyMessage = data.data
          if (data.data.scheduleType == 2) {
            this.TemplateScheduleType = []
            this.TemplateScheduleType.push('Day')
          } else {
            this.TemplateScheduleType = []
            this.TemplateScheduleType.push(
              ...['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            )
          }
        } else {
          this.TemplateBodyMessage = data.data
          this.TemplateScheduleType = []
        }
        this.$nextTick(() => {
          this.IsShowTemplate = 1
        })
      }
    },
    // 当前方格范围内的前一个最近事件
    getPreEvent (scopeStart, scopeEnd) {
      const scopeEvent = []
      let preEvent
      this.events.forEach((v) => {
        // 事件的结束时间是否在方格时间范围内
        if (v.endTime >= scopeStart && v.endTime <= scopeEnd) {
          scopeEvent.push(v)
        }
      })
      scopeEvent.sort((a, b) => a.startTime - b.startTime)
      // 如果点击分钟内有事件，开始时间紧跟这分钟内的结束时间
      if (scopeEvent.length) {
        preEvent = scopeEvent[scopeEvent.length - 1]
      }
      return preEvent
    },
    // 重新绑定拖拽
    registerDrag () {
      this.$nextTick(() => {
        this.dragToCreateEvent()
      })
    },
    // 元素绑定拖拽事件
    dragToCreateEvent (viewObj) {
      const view = viewObj || $('#calendar').fullCalendar('getView')
      let target
      const sourceList = document.querySelectorAll('.draggable_box .draggable_item')
      let dragElement = null
      let timeArr = []
      this.dateInfo.date.weekTitle = [undefined]
      for (let i = 0; i < sourceList.length; i++) {
        // 拖拽开始的时候触发
        const that = this
        sourceList[i].ondragstart = function () {
          dragElement = this // eslint-disable-line
          // 区别于template，medialist， live的拖动
          // 判断是否存在scheduleType属性
          // if (Object.prototype.hasOwnProperty.call(JSON.parse(dragElement.dataset.device), 'scheduleType')) that.templateDetailStatus = true
        }
      }
      switch (view.name) {
        case 'month':
          target = document.querySelector('.fc-body .fc-day-grid.fc-unselectable')
          break
        case 'agendaWeek':
          if (this.displayType) {
            target = document.querySelector('.list')
          } else {
            target = document.querySelector('.fc-slats table tbody')
          }

          break
        case 'agendaDay':
          if (this.displayType) {
            target = document.querySelector('.dayList')
          } else {
            target = document.querySelector('.fc-slats table tbody')
          }
          break
        case 'magnify':
          target = document.querySelector('.magnify .content .tbody')
          break
        default:
          target = document.querySelector('.fc-body .fc-day-grid.fc-unselectable')
          break
      }
      if (!target) {
        setTimeout(() => {
          switch (view.name) {
            case 'month':
              target = document.querySelector('.fc-body .fc-day-grid.fc-unselectable')
              break
            case 'agendaWeek':
              if (this.displayType) {
                target = document.querySelector('.list')
              } else {
                target = document.querySelector('.fc-slats table tbody')
              }
              break
            case 'agendaDay':
              if (this.displayType) {
                target = document.querySelector('.dayList')
              } else {
                target = document.querySelector('.fc-slats table tbody')
              }
              break
            case 'magnify':
              target = document.querySelector('.magnify .content .tbody')
              break
            default:
              target = document.querySelector('.fc-body .fc-day-grid.fc-unselectable')
              break
          }
        }, 100)
      }
      // 周日历或者是放大周.....将日期赋给this.dateInfo.date.date
      if (
        view.name == 'agendaWeek' ||
        (view.name == 'magnify' && this.dateInfo.date.date.length > 1)
      ) {
        const timeEle = $('.fc-head-container .fc-day-header')
        timeArr = []
        timeEle.map((i, v) => {
          timeArr.push($(v).attr('data-date').replace(/-/g, '/'))
          this.dateInfo.date.weekTitle.push($(v).find('a').html())
          return 1
        })
        this.dateInfo.date.date = timeArr
      }
      // 日 日历或者是放大日
      if (
        view.name == 'agendaDay' ||
        (view.name == 'magnify' && this.dateInfo.date.date.length == 1)
      ) {
        const timeEle = $('.fc-day-header.fc-widget-header')
        this.dateInfo.date.date = [timeEle.attr('data-date').replace(/-/g, '/')]
        this.dateInfo.date.weekTitle = [undefined, timeEle.find('span').html()]
      }
      if (view.name == 'magnify') return

      target.ondragover = function (e) {
        // 阻止默认事件
        // console.log(e,'ondragover');
        e.preventDefault()
      }

      // drop事件默认是触发不了的，需要在dragover事件里面阻止默认事件
      target.ondrop = (e) => {
        // 事件拖拽
        const id = dragElement.dataset.id
        if (id) {
          this.EventDragMove(e, id, view)
          return
        }
        const templateDetailStatus = dragElement.dataset.template
        const programTemplate = dragElement.dataset.programtemplate
        if (this.displayType == 1) {
          const ListMode = this.getListModeClickTime(e, view)
          const startTime = ListMode.startTime
          const endTime = ListMode.endTime
          if (!templateDetailStatus) {
            // 判断是否是program模板
            if (programTemplate === 'programtemplate') {
              this.DragProgramTemplate({
                startTime: new Date(startTime),
                endTime: new Date(endTime),
                event: JSON.parse(dragElement.dataset.device)
              })
            } else {
              this.ClickandDragCreate({
                startTime: new Date(startTime),
                endTime: new Date(startTime),
                event: JSON.parse(dragElement.dataset.device)
              }, e, 1)
            }
          } else {
            this.DragTemlateDetail(JSON.parse(dragElement.dataset.device), e)
          }
        } else {
          if (!templateDetailStatus) {
            const EventMode = this.getEventModeClickTime(e, view)
            const startDate = EventMode.startDate
            const stopDate = EventMode.stopDate
            // 小于当前时间不可创建
            if (startDate <= new Date().getTime()) {
              this.$message.error(this.$t('lang.startTimeLessThanCurTime'))
              return
            }
            // 判断是否是program模板
            if (programTemplate === 'programtemplate') {
              this.DragProgramTemplate({
                startTime: new Date(startDate),
                endTime: new Date(stopDate),
                event: JSON.parse(dragElement.dataset.device)
              })
            } else {
              this.ClickandDragCreate({
                startTime: new Date(startDate),
                endTime: new Date(stopDate),
                event: JSON.parse(dragElement.dataset.device)
              }, e, 1)
            }
          } else {
            this.DragTemlateDetail(JSON.parse(dragElement.dataset.device), e)
          }
        }
      }
    },
    // 事件拖拽
    EventDragMove (e, id, view) {
      let startTime = 0
      if (this.displayType == 1) {
        const ListMode = this.getListModeClickTime(e, view)
        startTime = ListMode.startTime
      } else {
        const EventMode = this.getEventModeClickTime(e, view)
        startTime = EventMode.startDate
      }
      if (!startTime) return
      const param = {
        cancelFirstEventFollowOn: false,
        programId: this.$BehaviorSyns.getProgramId(),
        eventIds: id,
        coverEvent: false,
        operationType: 0,
        startTime: startTime
      }
      this.loadingCalendar = true
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/moveEvents'),
        data: param
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.$message({
            message: this.$t('lang.success'),
            type: 'success'
          })
          // 删除成功后刷新列表
          this.getBookingEventAccodT(true)
          this.loadingCalendar = false
        } else {
          const errorInfo =
            this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
          this.loadingCalendar = false
        }
      }).catch(() => {
        this.loadingCalendar = false
      })
    },
    // 获取列表模式点击时间
    getListModeClickTime (e, view) {
      let startTime
      let endTime
      const target = e.target
      if (target.className == 'preTimeGap' || target.className == 'firstTimeGap' || target.parentElement.className == 'preTimeGap' || target.parentElement.className == 'firstTimeGap') {
        if (view.name === 'agendaWeek') {
          const index = e.target.dataset.index * 1 || e.target.parentElement.dataset.index * 1
          if (new Date().getTime() > this.aheadTimeArr[index] || new Date().getTime() == this.aheadTimeArr[index]) {
            startTime = new Date().getTime() + 1 * 60 * 1000
          } else {
            startTime = this.aheadTimeArr[index]
          }
        } else {
          const changedStartTime = new Date(`${this.getCurrenTime()[0]} ${this.TimeQuantum}:00:00`).getTime()
          if (new Date().getTime() > changedStartTime || new Date().getTime() == changedStartTime) {
            startTime = new Date().getTime() + 1 * 60 * 1000
          } else {
            startTime = changedStartTime
          }
        }
      } else if (target.className == 'lastTimeGap' || target.parentElement.className == 'lastTimeGap') {
        const nowTimeDate = new Date().getTime()
        let preEndTime
        if (view.name === 'agendaWeek') {
          const index = e.target.dataset.index || e.target.parentElement.dataset.index
          const targetArr = this.eventModesList[index * 1]
          preEndTime = targetArr[targetArr.length - 1].endTime
        } else {
          preEndTime = this.eventDayList[this.eventDayList.length - 1].endTime
        }
        if (nowTimeDate < preEndTime) {
          startTime = preEndTime
        } else {
          startTime = new Date().getTime() + 60 * 1000
        }
      } else if (target.className == 'timeGap' || target.parentElement.className == 'timeGap') {
        let targetData
        if (target.className == 'timeGap') {
          targetData = e.target
        } else {
          targetData = e.target.parentElement
        }
        const startGap = targetData.dataset.startgap * 1
        const endGap = targetData.dataset.endgap * 1
        const nowTimes = new Date().getTime() + 60 * 1000
        if (startGap < nowTimes && nowTimes < endGap) {
          startTime = new Date().getTime() + 60 * 1000
        } else {
          startTime = targetData.dataset.startgap * 1
        }
      }
      if (view.name === 'agendaWeek') {
        const index = e.target.dataset.index * 1 || e.target.parentElement.dataset.index * 1
        endTime = this.aheadTimeArr[index] + 24 * 60 * 60 * 1000
      } else {
        endTime = new Date(`${this.getCurrenTime()[0]} ${this.TimeQuantum}:00:00`).getTime() + 24 * 60 * 60 * 1000
      }
      return {
        startTime,
        endTime
      }
    },
    // 获取时间表模式点击时间
    getEventModeClickTime (e, view) {
      let startDate // 落下所在块的时间2021/03/11 06:30:00
      let stopDate // 2021/03/11 07:00:00
      let distance // 落下的位置距离日历边缘距离
      let index // 落下周几
      let date // 落下的日期2021/03/11
      // 获取落到那一天的哪一半
      let IsLeftHalf = false
      const targetX = $('#calendar').offset() && $('#calendar').offset().left
      const timeArr = this.getCurrenTime()
      if (view.name === 'month') {
        index =
        $(e.target).parent().find('td').index($(e.target)) -
        $(e.target).parent().find('.fc-more-cell').length
        const parent = $(e.target).parents(
          '.fc-row.fc-week.fc-widget-content.fc-rigid'
        )
        const targetEle = parent.find(`.fc-day:eq(${index})`)
        startDate = `${$(targetEle)
        .attr('data-date')
        .replace(/-/g, '/')} 00:00:00`
        const stop = Outil.getDateTime(
          new Date(new Date(startDate).getTime() + 24 * 60 * 60 * 1000)
        )
        stopDate = `${stop.year}/${stop.month}/${stop.day} ${stop.hour}:${stop.min}:${stop.s}`
        distance = e.clientX - targetX
      } else if (view.name === 'agendaWeek') {
        const startTime = $(e.target).parent().attr('data-time')
        const StopHours = Number(startTime.split(':')[0]) + 1 < 10 ? `0${Number(startTime.split(':')[0]) + 1}` : Number(startTime.split(':')[0]) + 1
        const stopTime =
        startTime.split(':')[1] == '30'
          ? `${StopHours}:00:00`
          : `${startTime.split(':')[0]}:30:00`
        // 落下的位置距离日历边缘距离
        distance = e.clientX - targetX - 39
        index = Math.floor(
          distance / (($(e.target).width() - 2) / 7).toFixed(2)
        )
        IsLeftHalf = Math.floor(distance / (($(e.target).width() - 2) / 14).toFixed(2)) % 2 == 0
        date = timeArr[index].replace(/-/g, '/')
        startDate = `${date} ${startTime}`
        this.editEventStart = `${timeArr[index]} ${startTime}`
        stopDate = `${date} ${stopTime}`
      } else if (view.name === 'agendaDay') {
        distance = e.clientX - targetX - 39
        IsLeftHalf = Math.floor(distance / (($(e.target).width() - 2) / 2).toFixed(2)) % 2 == 0
        date = $('.fc-day-header.fc-widget-header')
          .attr('data-date')
          .replace(/-/g, '/')
        const start = $(e.target).parent().attr('data-time')
        startDate = `${date} ${start}`
        const time = Outil.getDateTime(
          new Date(new Date(startDate).getTime() + 30 * 60 * 1000)
        )
        stopDate = `${time.year}/${time.month}/${time.day} ${time.hour}:${time.min}:${time.s}`
      } else if (view.name === 'magnify') {
        startDate = `${$(e.target).attr('data-date').replace(/-/g, '/')} ${$(e.target).attr(
        'data-time'
      )}`
        stopDate = new Date(startDate).getTime() + 1000
      }
      let DSTType = 0
      let DSTType1 = 0
      const startDateString = startDate
      const stopDateString = stopDate
      startDate = new Date(startDate).getTime()
      stopDate = new Date(stopDate).getTime()
      if (view.name != 'magnify' && view.name != 'month') {
        // 拖拽到夏令时特殊处理
        if (this.DstTime.isDst && this.TimeQuantum) {
          const DSTstartTime = `${Outil.changeNewDate(startDate, 1)} ${Outil.changeNewTime(startDate)}`
          const DSTstopTime = `${Outil.changeNewDate(stopDate, 1)} ${Outil.changeNewTime(stopDate)}`
          if (startDateString != DSTstartTime) {
            DSTType = 1
          }
          if (stopDateString != DSTstopTime) {
            DSTType1 = 1
          }
        }
        startDate = this.getRenderingTime('+', startDate, DSTType)
        stopDate = this.getRenderingTime('+', stopDate, DSTType1)
      }
      //  拿到离时间最近的一个事件
      const preEvent = this.getPreEvent(
        startDate,
        stopDate
      )
      if (preEvent) {
        const differ = stopDate - startDate
        startDate = preEvent.endTime
        stopDate = startDate + differ
      }
      return {
        startDate,
        stopDate
      }
    },
    // 拖拽模板
    DragTemlateDetail (data, e, startTime) {
      const view = $('#calendar').fullCalendar('getView')
      const targetX = $('#calendar').offset().left
      let CreateStartTime
      let CreateStartTime1 // 有值代表拖拽周模板
      let TimeList = []
      if (view.name == 'month') {
        return
      } else if (view.name == 'agendaWeek') {
        const timeEle = $('.fc-head-container .fc-day-header')
        timeEle.map((i, v) => {
          TimeList.push($(v).attr('data-date').replace(/-/g, '/'))
          return 1
        })
        // 落下的位置距离日历边缘距离
        let distance, index //  落下的第几天
        if (this.displayType == 1) {
          distance = e.clientX - targetX
          index = Math.floor(
            distance / (this.headWith + 2)) * 1
        } else {
          distance = e.clientX - targetX - 39
          index = Math.floor(
            distance / (($(e.target).width() - 2) / 7).toFixed(2)
          )
        }
        let TimeQuantum = this.TimeQuantum
        // 判断使用模板的几点开始，还是channel的几点开始
        if (!(data.absoluteTime == null || data.absoluteTime == undefined)) {
          TimeQuantum = data.absoluteTime
        }
        CreateStartTime = moment(`${TimeList[index]} ${TimeQuantum}:00:00`).tz(this.homeTimeZone, true).valueOf()
        if (data.scheduleType == 1) {
          CreateStartTime1 = moment(`${TimeList[0]} ${TimeQuantum}:00:00`).tz(this.homeTimeZone, true).valueOf()
        }
      } else if (view.name == 'agendaDay') {
        const timeEle = $('.fc-day-header.fc-widget-header')
        TimeList = [timeEle.attr('data-date').replace(/-/g, '/')]
        if (data.absoluteTime == null || data.absoluteTime == undefined) {
          CreateStartTime = moment(`${TimeList[0]} ${TimeQuantum}:00:00`).tz(this.homeTimeZone, true).valueOf()
        } else {
          CreateStartTime = moment(`${TimeList[0]} ${data.absoluteTime}:00:00`).tz(this.homeTimeZone, true).valueOf()
        }
      }
      // 选择时间
      if (CreateStartTime1) {
        this.SchedulerDragTime = {
          show: true,
          data: data,
          CreateStartTime: CreateStartTime,
          CreateStartTime1: CreateStartTime1
        }
        return
      }
      this.checkTemplateConflict(data, CreateStartTime)
    },
    // 拖拽时间选择
    DragTimeSelect (type) {
      if (type == 1) {
        this.checkTemplateConflict(this.SchedulerDragTime.data, this.SchedulerDragTime.CreateStartTime1)
      } else {
        this.checkTemplateConflict(this.SchedulerDragTime.data, this.SchedulerDragTime.CreateStartTime)
      }
    },
    // 检查是否冲突
    checkTemplateConflict (data, CreateStartTime) {
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/template/checkTemplateConflict', {
        templateId: data.id,
        startTime: CreateStartTime,
        rid: this.selectR.peerId
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            const param = {
              id: data.id,
              startTime: CreateStartTime,
              rid: this.selectR.peerId,
              coverEvent: false
            }
            if (!res.data.result) {
              this.$confirm(this.$t('lang.scheduleConflict'), {
                confirmButtonText: this.$t('lang.Confirm'),
                cancelButtonText: this.$t('lang.cancel'),
                type: ''
              })
                .then(() => {
                  param.coverEvent = true
                  this.ApplicationTemplate(param)
                })
                .catch(() => {
                  this.ApplicationTemplate(param)
                })
            } else {
              this.ApplicationTemplate(param)
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        } else {
          this.$message({
            type: 'warning',
            message: this.$t('lang.serverFailed')
          })
        }
      }).catch(() => {})
    },
    // 调接口用模板创建事件
    ApplicationTemplate (param) {
      this.loadingCalendar = true
      this.axios
        .post('/gatewayPlayoutUrl/tvu-playout/template/userTemplate', param, {
          timeout: 120000
        })
        .then((res) => {
          this.loadingCalendar = false
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              this.$message({
                type: 'success',
                message: this.$t('lang.success')
              })
              this.getBookingEventAccodT()
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.error(errorInfo)
            }
          } else {
            this.$message({
              type: 'warning',
              message: this.$t('lang.serverFailed')
            })
          }
        }).catch(() => {
          this.$alert(this.$t('lang.TemplateTimeout'), {
            confirmButtonText: this.$t('lang.Refresh'),
            callback: action => {
              this.getBookingEventAccodT()
            }
          })
          this.loadingCalendar = false
        })
    },
    // 拖拽program模板
    DragProgramTemplate (data) {
      this.axios
        .post('/gatewayPlayoutUrl/tvu-playout/event/addEventByTemplateId', {
          eventTemplateId: data.event.id,
          startTime: data.startTime.getTime(),
          receiverId: this.selectR.peerId
        })
        .then((res) => {
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              this.$message({
                type: 'success',
                message: this.$t('lang.success')
              })
              this.getBookingEventAccodT()
            } else {
              const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }
        }).catch(() => {})
    },
    // 重新创建事件
    ClickandDragCreate (eventMessage, jsEvent, type) {
      // 先关闭弹出框
      this.EventMotion.switch = false
      // 计算弹出框位置
      this.SetFramePosition(jsEvent)
      // type 0 点击空白创建  1拖拽创建
      if (type) {
        if (['file', 'video'].includes(eventMessage.event.type.toLowerCase())) {
          if (this.PitchOnFileList[eventMessage.event.id]) {
            const ListStartTime = eventMessage.startTime.getTime()
            if (!this.MediaIsRound) {
              // 判断多个文件时间是否有浮点数
              const IsRound = Object.keys(this.PitchOnFileList).some((key) => {
                const item = this.PitchOnFileList[key]
                const videoTimes = item.videoTimes ? Number(item.videoTimes) : 0
                // 判断是否是浮点数
                return parseInt(videoTimes) !== videoTimes
              })
              if (IsRound) {
                this.MediaTimeFloor.show = true
                this.MediaTimeFloor.type = 'batch'
                this.MediaTimeFloor.ListStartTime = ListStartTime
                return
              }
            }
            this.batchAddEvent(ListStartTime, true)
          } else {
            this.form = {
              title: eventMessage.event.name,
              color: eventMessage.event.setType == 'break' ? 'rgb(146, 72, 199)' : 'rgb(255, 192, 0)',
              tname: eventMessage.event.name,
              rname: this.selectR.name,
              tpeerid: eventMessage.event.sourceId,
              rpeerid: this.selectR.peerId,
              record: 0,
              startTime: eventMessage.startTime.getTime(),
              endTime: eventMessage.startTime.getTime() + Number(eventMessage.event.videoTimes) * 1000,
              ttype: eventMessage.event.type,
              scheduleType: 'live',
              sourceType: 0,
              duration: Number(eventMessage.event.videoTimes)
            }
            let videoTimes = this.form.duration
            // 判断是否是浮点数
            if (parseInt(videoTimes) !== videoTimes) {
              // 判断是否需要取整
              if (this.MediaIsRound) {
                videoTimes = Math.floor(videoTimes)
              } else {
                this.MediaTimeFloor.show = true
                this.MediaTimeFloor.type = 'single'
                return
              }
            }

            this.form.duration = videoTimes * 1000
            this.form.endTime = this.form.startTime + videoTimes * 1000
            this.createBooking(this.form)
          }
        } else {
          this.createBooking({
            title: eventMessage.event.name,
            color: 'rgb(255, 192, 0)',
            tname: eventMessage.event.name,
            rname: this.selectR.name,
            tpeerid: eventMessage.event.peerId,
            rpeerid: this.selectR.peerId,
            record: 0,
            startTime: eventMessage.startTime.getTime(),
            endTime: eventMessage.startTime.getTime() + 30 * 60 * 1000,
            ttype: eventMessage.event.type,
            scheduleType: 'live',
            sourceType: 1,
            duration: 30 * 60 * 1000
          })
        }
      } else {
        // 禁止里层滚动条滚动
        $('.fc-scroller.fc-time-grid-container').css('overflow-y', 'hidden')
        this.picthOnEvent = {
          startTime: eventMessage.startTime.getTime(),
          endTime: eventMessage.endTime.getTime(),
          tpeerid: '',
          record: false,
          //   新加子事件scte属性
          eventSegments: [],
          timeLock: 0,
          pgmEndScte: 0,
          pgmStartScte: 0,
          multipleModelType: 0
        }
        this.$nextTick(() => {
          this.EventMotion.motion = 2
          this.EventMotion.switch = true
        })
      }
    },
    // 编辑booking事件
    fillCreateBox (event, jsEvent, type) {
      // type  1是编辑 0是查看
      // 先关闭弹出框
      this.EventMotion.switch = false
      // 计算弹出框位置
      this.SetFramePosition(jsEvent)

      this.curLiveStatus = null
      // 事件的一些信息
      const infoObj = event.eventData
      // 保存点击的事件id
      this.deleteId = event.id
      //  拿取对应的子事件
      const CurrentEvent = this.PageAllEvent.filter((item) => item.id == event.id)
      this.picthOnEvent = {
        ...CurrentEvent[0],
        id: event.id,
        title: infoObj.title,
        color: this.mateColor(event.colorName),
        reporter: infoObj.reporter,
        description: infoObj.description,
        tname: infoObj.tname,
        rname: infoObj.rname,
        tpeerid: infoObj.tpeerid,
        rpeerid: infoObj.rpeerid,
        record: !!event.item.record,
        startTime: type ? event.start._d.getTime() : CurrentEvent[0].startTime,
        endTime: type ? event.end._d.getTime() : CurrentEvent[0].endTime,
        delay: infoObj.delay,
        bitrate: infoObj.bitrate,
        ttype: infoObj.type,
        eventId: event.id,
        duration: '',
        houseId: CurrentEvent[0].houseId,
        sourceType: CurrentEvent[0].sourceType,
        //   新加子事件scte属性
        eventSegments: JSON.parse(JSON.stringify(CurrentEvent[0].eventSegments))
      }
      // 拖拽编辑时时间已经发生变化
      if (type) {
        // 初始时间的变化
        const EventTimeChange =
          this.picthOnEvent.startTime - CurrentEvent[0].startTime
        // 变化子事件时间
        this.picthOnEvent.eventSegments.forEach((item, index) => {
          if (EventTimeChange) {
            item.timingIn = item.timingIn + EventTimeChange
            item.timingOut = item.timingOut + EventTimeChange
          }
        })
      }
      NotManyEdit.checkUserEdit({ type: 0, logicId: this.picthOnEvent.id }).then((res) => {
        if (res) {
          // 禁止里层滚动条滚动
          $('.fc-scroller.fc-time-grid-container').css('overflow-y', 'hidden')
          // 如果已经开始live了
          this.$nextTick(() => {
            this.EventMotion.motion = type ? 1 : 0
            this.EventMotion.switch = true
          })
        } else {
          this.closeCreateBox()
        }
      })
    },
    // 关闭创建box
    closeCreateBox () {
      // 事件挪动位置的回归
      if (this.dragEvent.id) {
        $('#calendar').fullCalendar('removeEvents')
        $('#calendar').fullCalendar('renderEvents', this.events, true)
        this.dragEvent = {}
      }

      $('#calendar').fullCalendar('unselect') // 清空选中区域
      $('.fc-scroller.fc-time-grid-container').css('overflow-y', 'scroll') // 开启里层滚动条滚动
      const CreateBoxSwitch = this.EventMotion.switch
      // 初始化数据
      this.initEventData()
      if (CreateBoxSwitch) {
        this.$nextTick(() => {
          // 添加DR图标
          this.AddDRicon()
        })
      }
    },
    OperationSuccess () {
      this.closeCreateBox() // 关闭弹窗
      // 删除成功后刷新列表
      this.getBookingEventAccodT()
    },
    // 关闭创建框初始化数据
    initEventData () {
      this.EventMotion.switch = false
      this.editStatus = {}
    },
    // 取整选择结果
    RoundSelectRes (value) {
      if (this.MediaTimeFloor.type == 'single') {
        let videoTimes = this.form.duration
        if (value == 1) {
          videoTimes = Math.floor(videoTimes)
        }
        this.form.duration = videoTimes * 1000
        this.form.endTime = this.form.startTime + videoTimes * 1000
        this.createBooking(this.form)
      } else if (this.MediaTimeFloor.type == 'batch') {
        const ListStartTime = this.MediaTimeFloor.ListStartTime
        const IsRound = value == 1
        this.batchAddEvent(ListStartTime, IsRound)
      }
    },
    // 批量添加事件
    batchAddEvent (startTime, IsRound) {
      const EventList = []
      let ListStartTime = startTime
      Object.keys(this.PitchOnFileList).forEach(key => {
        const item = this.PitchOnFileList[key]
        let duration = item.videoTimes ? Number(item.videoTimes) : 0
        duration = IsRound ? Math.floor(duration) : duration
        const eventParam = {
          bitrate: 5120,
          color: item.setType == 'break' ? 'rgb(146, 72, 199)' : 'rgb(255, 192, 0)',
          delay: 2,
          rpeerid: this.selectR.peerId,
          scheduleType: 'live',
          sourceType: 0,
          title: item.name,
          name: item.name,
          tpeerid: item.peerId || item.sourceId,
          ttype: item.type,
          turl: item.url,
          duration: duration * 1000
        }
        eventParam.startTime = ListStartTime
        eventParam.endTime = eventParam.startTime + eventParam.duration
        const eventSegments = {
          segmentId: 1,
          segmentOrder: 0,
          timingIn: eventParam.startTime,
          timingOut: eventParam.endTime
        }
        eventParam.eventSegments = [eventSegments]
        ListStartTime = eventParam.endTime
        EventList.push(eventParam)
      })
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/batchAdd'),
        data: {
          eventParams: EventList
        }
      }).then((res) => {
        if (res.status == 200 && res.data.errorCode == '0x0') {
          // 成功后刷新列表
          this.getBookingEventAccodT()
          return
        }
        const errorInfo =
          this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
        this.$message.error(errorInfo)
      }).catch(() => {})
    },
    // 强制填充弹框确认
    forceFillSelect (type) {
      if (type == 1) {
        this.form.startTime = this.GapTime.startTime
        this.form.endTime = this.GapTime.endTime
      } else {
        this.form.startTime = this.GapTime.startTime
        this.form.moveAllEventMoreThanEndTime = 1
      }
      this.addEvent(this.form)
    },
    // 发送请求创建booking
    async createBooking (param) {
      if (!param.title.trim() && param.title !== 0) {
        this.$message.error(this.$t('lang.titleEmpty'))
        return
      }
      if (!param.rpeerid) {
        this.$message.error(this.$t('lang.rEmpty'))
        return
      }
      // 实时流填充间隙
      if (param.sourceType == 1) {
        const GapTime = await Outil.getEventGap(param.startTime)
        if (GapTime && GapTime.duration > 0) {
          if (GapTime.duration <= 1800000) {
            param.startTime = GapTime.startTime
            param.endTime = GapTime.endTime
          }
        }
        param.record = this.AdvancedSetupConfig.defaultSecondaryRecord ? 1 : 0
        param.replay = param.record
      } else if (param.sourceType == 0) {
        const GapTime = await Outil.getEventGap(param.startTime)
        this.GapTime = GapTime
        if (GapTime.forcePopulate) {
          if (GapTime.duration != -2) {
            if (GapTime && GapTime.duration > 0) {
              if (GapTime.duration < param.duration) {
                this.forceFillMessage.show = true
                return
              }
            }
          }
        }
      }
      this.addEvent(param)
    },
    // 创建event
    addEvent (param) {
      if (param.title.length > 220) {
        this.$message.error(this.$t('lang.eventTitleLength'))
        return
      }
      const eventSegments = {
        segmentId: 1,
        segmentOrder: 0,
        timingIn: param.startTime,
        timingOut: param.endTime
      }
      param.eventSegments = [eventSegments]
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/add'),
        data: param,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.closeCreateBox() // 关闭弹窗
            // 成功后刷新列表
            this.getBookingEventAccodT()
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }
      }).catch(() => {})
    },
    // 窗口大小调整
    handleResize () {
      // this.calendarFlag = false;
      // this.calendarConfig.contentHeight = document.body.offsetHeight - 190;
      this.EventMotion.switch = false
      if (document.body.clientWidth > 1024) {
        this.isShow.rList = true
        this.isShow.sourceList = true
        this.calendar.searchS = false
        this.calendar.searchR = false
      } else {
        this.isShow.rList = false
        this.isShow.sourceList = false
        this.calendar.searchS = true
        this.calendar.searchR = true
      }
      // this.$nextTick(() => {
      //     this.calendarFlag = true;
      // })
      this.initScroll()
    },
    // 注册滚动事件
    initScroll () {
      if (this.timer.refetchEvent) {
        clearTimeout(this.timer.refetchEvent)
        this.timer.refetchEvent = null
      }
      // 取消监听
      $('.magnifying .body').off('scroll')
      $('.fc-scroller.fc-time-grid-container').off('scroll')

      // 两边滚动一样
      this.$nextTick(() => {
        this.calendarHeight = $('.fc-view-container .fc-slats tbody').height()
        let scrollTopLeft = 0
        let scrollTopRight = 0

        scrollTopRight = $('.fc-scroller.fc-time-grid-container').scrollTop()
        $('.magnifying .body').scrollTop(scrollTopRight)

        $('.fc-scroller.fc-time-grid-container').scroll((event) => {
          scrollTopRight = $('.fc-scroller.fc-time-grid-container').scrollTop()
          if (scrollTopRight !== scrollTopLeft) {
            $('.magnifying .body').scrollTop(scrollTopRight)
          }
          this.RecordScrollHeight = scrollTopRight
        })
        $('.magnifying .body').scroll((event) => {
          scrollTopLeft = $('.magnifying .body').scrollTop()
          if (scrollTopRight !== scrollTopLeft) {
            $('.fc-scroller.fc-time-grid-container').scrollTop(scrollTopLeft)
          }
        })
        // 默认滚动到当前时间
        const Hours = new Date().getHours()
        const scrollHeight = Hours >= this.TimeQuantum ? Hours - this.TimeQuantum : Hours + 23 - this.TimeQuantum
        $('.fc-scroller.fc-time-grid-container').scrollTop(
          scrollHeight * 301
        )

        $('.magnifying .header').css(
          'height',
          $('.fc-widget-header th.fc-widget-header').height() + 2
        )
        this.dragToCreateEvent()
      })
    },
    // 切换输入框
    changeActiveStatus (curKey, value) {
      for (const key in this.heavyLoadObj.active) {
        if (key == curKey) {
          this.heavyLoadObj.active[key] = value
        } else {
          this.heavyLoadObj.active[key] = false
        }
      }
    },
    // 判断事件状态
    eventStatus (eventId) {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/getEventById'),
        data: { eventId },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          const { result } = res.data
          if (result.liveStatus == 1 || result.liveStatus == 5) {
          // running
            if (result.liveStatus == 1) {
              this.isShow.deleteBtn = false
            }
            this.curLiveStatus = result.liveStatus
            this.EventMotion.motion = 0
            this.EventMotion.switch = true
          } else if (result.liveStatus === 2 || result.liveStatus === 4) {
          // this.removeCalendarEvent(eventId)
            this.EventMotion.motion = 0
            this.EventMotion.switch = true
          }
        } else {
          const errorInfo =
            this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 移除已经结束的事件
    removeCalendarEvent (eventId) {
      $('#calendar').fullCalendar('removeEvents', eventId)
      this.$message.error(this.$t('lang.invalidEvent'))
    },
    // 计算弹出框位置
    SetFramePosition (jsEvent) {
      const ClickEvent = jsEvent || window.event
      const calendarLeft =
        document.getElementsByClassName('calendarLeft')[0].clientWidth +
        document.getElementsByClassName('magnifying')[0].clientWidth
      const calendarRight = document.getElementById('calendar')
      const calendarRightTop = calendarRight.getBoundingClientRect().top
      const FramePosition = {
        top: ClickEvent.clientY - calendarRightTop,
        left: ClickEvent.clientX - calendarLeft,
        bottom: calendarRight.clientHeight - ClickEvent.clientY + calendarRightTop,
        right: calendarRight.clientWidth - ClickEvent.clientX + calendarLeft,
        ArrowsLeft: 60
      }
      if (this.displayType) {
        if (FramePosition.bottom > -300 && FramePosition.right >= 700) {
          this.createBox.top = FramePosition.top
          this.createBox.left = FramePosition.left - 70
          this.createBox.upward = true
          this.createBox.aleft = true
        } else if (FramePosition.bottom > -300 && FramePosition.right <= 700) {
          this.createBox.top = FramePosition.top
          this.createBox.left = FramePosition.left + 70
          this.createBox.upward = true
          this.createBox.aleft = false
        } else if (FramePosition.bottom < -300 && FramePosition.right < 700) {
          this.createBox.top = FramePosition.top
          this.createBox.left = FramePosition.left + 70
          this.createBox.upward = false
          this.createBox.aleft = false
        } else {
          this.createBox.top = FramePosition.top
          this.createBox.left = FramePosition.left - 70
          this.createBox.upward = false
          this.createBox.aleft = true
        }
      } else {
        if (FramePosition.bottom >= 430 && FramePosition.right >= 700) {
          this.createBox.top = FramePosition.top
          this.createBox.left = FramePosition.left - 70
          this.createBox.upward = true
          this.createBox.aleft = true
        } else if (FramePosition.bottom < 430 && FramePosition.right >= 700) {
          this.createBox.top = FramePosition.top
          this.createBox.left = FramePosition.left - 70
          this.createBox.upward = false
          this.createBox.aleft = true
        } else if (FramePosition.bottom >= 430 && FramePosition.right < 700) {
          this.createBox.top = FramePosition.top
          this.createBox.left = FramePosition.left + 70
          this.createBox.upward = true
          this.createBox.aleft = false
        } else {
          this.createBox.top = FramePosition.top
          this.createBox.left = FramePosition.left + 70
          this.createBox.upward = false
          this.createBox.aleft = false
        }
      }
      const ScreenDistance = {
        left: ClickEvent.clientX,
        right: document.body.scrollWidth - ClickEvent.clientX
      }
      let Translation = 0
      if (this.createBox.aleft && ScreenDistance.right < 855) {
        Translation = ScreenDistance.right - 855
      } else if (!this.createBox.aleft && ScreenDistance.left < 855) {
        Translation = 855 - ScreenDistance.left
      }
      this.createBox.ArrowsLeft = FramePosition.ArrowsLeft + Math.abs(Translation)
      this.createBox.ArrowsLeft = this.createBox.ArrowsLeft > 360 ? 360 : this.createBox.ArrowsLeft
      this.createBox.top = this.createBox.top
      this.createBox.left = this.createBox.left + Translation
    },
    initSourcePar (val) {
      this.sourcePar.pack = val
      this.sourcePar.anywhere = val
      this.sourcePar.gridPack = val
      this.sourcePar.gridSdi = val
      this.sourcePar.ext = val
      this.sourcePar.token = val
      this.sourcePar.scte = val
    },
    // 获取日历时间title更改自己的title
    changeCalTitle () {
      var title = $('.fc-center h2').html()
      $('.replace_title').html(title)
      if (this.DstTime.isDst) {
        const timeEle = $('.fc-head-container .fc-day-header')
        const timeArr = []
        timeEle.map((i, v) => {
          timeArr.push($(v).attr('data-date'))
          return 1
        })
        let DstTime = this.DstTime
        const getYear = new Date().getYear()
        const date = this.getCurrenTime()[0]
        const Year = date ? date.substring(0, 4) : getYear
        if (getYear != Year) {
          DstTime = Outil.DisplayDstSwitchDates(Year)
        }
        // 夏令时开始
        const DstStart = Outil.changeNewDate(DstTime.firstDstDate.tmpDate.getTime())
        const indexStart = timeArr.indexOf(DstStart)
        if (timeArr.length > 0 && indexStart != -1) {
          $('.fc-head-container .fc-day-header').eq(indexStart).children('.Daylightstarts').remove()
          const Daylightstarts = '<div class="Daylightstarts" style="background: #068043;">Daylight Saving Time starts</div>'
          $('.fc-head-container .fc-day-header').eq(indexStart).append(Daylightstarts)
        }
        // 夏令时结束
        const DstEnd = Outil.changeNewDate(DstTime.secondDstDate.tmpDate.getTime())
        const indexEnd = timeArr.indexOf(DstEnd)
        if (timeArr.length > 0 && indexEnd != -1) {
          $('.fc-head-container .fc-day-header').eq(indexEnd).children('.Daylightends').remove()
          const Daylightends = '<div class="Daylightends" style="background: #068043;">Daylight Saving Time ends</div>'
          $('.fc-head-container .fc-day-header').eq(indexEnd).append(Daylightends)
        }
      }
    },
    preDate () {
      // 上一视图日历
      playoutAnalyze(`${googleKey}DatePreClick`, '/po')
      $('#calendar').fullCalendar('prev')
      this.changeCalTitle()
      this.closeCreateBox()
      this.getBookingEventAccodT()
      // 滚动到指定位置
      $('.fc-scroller.fc-time-grid-container').scrollTop(this.RecordScrollHeight)
      // 删除月视图的日期
      this.DeleteMonthDate()
      this.LeftNavDate()
      if (this.displayType) {
        $('.fc-axis').hide()
      }
    },
    nextDate () {
      // 下一视图日历
      playoutAnalyze(`${googleKey}DateNextClick`, '/po')
      $('#calendar').fullCalendar('next')
      this.changeCalTitle()
      this.closeCreateBox()
      this.getBookingEventAccodT()
      // 滚动到指定位置
      $('.fc-scroller.fc-time-grid-container').scrollTop(this.RecordScrollHeight)
      // 删除月视图的日期
      this.DeleteMonthDate()
      this.LeftNavDate()
      if (this.displayType) {
        $('.fc-axis').hide()
      }
    },
    // 换侧边栏时间
    LeftNavDate () {
      const arr1 = $('.fc-slats .fc-widget-content span')
      $.each(arr1, (index, item) => {
        const TimeName = this.TimeFormat ? this.timeArr[index].name1 : this.timeArr[index].name
        $(item).html(TimeName)
      })
    },
    refreshEvents () {
      this.$refs.calendar.$emit('refetch-events')
    },
    eventSelected (event) {
      this.selected = event
    },
    eventCreated () {
      this.config.selectable = false
    },
    dayClick (event, jsEvent, view) {
      jsEvent.stopPropagation()
    },
    // 显示对应的元素
    showEle (keyVal) {
      if (keyVal == 'filterBox') {
        playoutAnalyze(`${googleKey}CalendarFilterIconClick`, '/po')
        if (document.body.clientWidth <= 1024) {
          this.isShow.sourceList = false
        }
      }
      if (keyVal == 'searchS') {
        playoutAnalyze(`${googleKey}SourceConditionClick`, '/po')
      }
      if (keyVal == 'searchR') {
        playoutAnalyze(`${googleKey}RConditionClick`, '/po')
      }
      for (var key in this.calendar) {
        if (keyVal == key) {
          this.calendar[key] = !this.calendar[key]
        } else {
          this.calendar[key] = false
        }
      }
      if (document.body.clientWidth <= 1024) {
        this.calendar.searchS = true
        this.calendar.searchR = true
      }
      this.sourcePar.condition = this.lastSourceCondition
        ? this.lastSourceCondition
        : ''
      this.rPar.condition = ''
    },
    // 放大日历表
    openCalendar (index, type) {
      // playoutAnalyze(`bookingZoomOpen`, '/po');
      // index=0;
      this.closeCreateBox()
      const view = $('#calendar').fullCalendar('getView')
      if (!['agendaWeek', 'agendaDay'].includes(view.name)) {
        this.$message.error(this.$t('lang.switchToWeek'))
        return
      }
      this.dateInfo.date.date = []
      const timeArr = this.getCurrenTime()
      this.dateInfo.date.date = timeArr
      let TimeGrid = index + this.TimeQuantum * 2
      if (TimeGrid >= 48) {
        TimeGrid = TimeGrid - 48
        const NestDay = new Date(timeArr[timeArr.length - 1]).getTime() + 26 * 60 * 60 * 1000
        this.dateInfo.date.date.splice(0, 1)
        this.dateInfo.date.date.push(Outil.changeNewDate(NestDay, 1))
      }
      this.transformTime(TimeGrid * 30)
      this.dateInfo.show = true
    },
    // 转换时间
    transformTime (time) {
      const endTime = time + 60
      const start = `${Math.floor(time / 60) > 9 ? '' : '0'}${Math.floor(
        time / 60
      )}:${time % 60 > 9 ? '' : '0'}${time % 60}`
      const end = `${Math.floor(endTime / 60)}:${endTime % 60}`
      this.dateInfo.date.start = start
      this.dateInfo.date.end = end
    },
    // 选择源
    chooseSource (item) {
      this.selectSource = JSON.parse(JSON.stringify(item))
      item.peerId = item.peerId || item.id
      this.creating = false // 隐藏创建booking信息展示
      this.rPar.tpeerId = item.peerId // 更改获取R列表的参数T的peerId
      this.rPar = JSON.parse(JSON.stringify(this.rPar))
      this.rPar.pageNum = 1
    },
    // 选择R
    currentSelectData (item) {
      this.selectR = JSON.parse(JSON.stringify(item))
      this.currentSelectPeerid = item.peerId
      this.EventMotion.switch = false
      this.getBookingEventAccodT()
      this.closeCreateBox()
    },
    // close down list
    closeDownList () {
      this.isShow.showColorOpt = false
    },
    // show color box option
    showColorOpt () {
      this.isShow.showColorOpt = !this.isShow.showColorOpt
      const googleAnalyzeEvent = `${googleKey}EventColorOpen`
      if (!this.isShow.showColorOpt) return
      playoutAnalyze(googleAnalyzeEvent, '/po')
    },
    prevent (e) {
      e.stopPropagation()
      this.isShow.createBoxSourceList = false
    },
    showWeekFirstDay () {
      var nowTemp = new Date() // 当前时间
      var oneDayLong = 246060 * 1000 // 一天的毫秒数
      var c_time = nowTemp.getTime() // 当前时间的毫秒时间
      var c_day = nowTemp.getDay() || 7 // 当前时间的星期几
      var m_time = c_time - (c_day - 1) * oneDayLong // 当前周一的毫秒时间
      var monday = new Date(m_time) // 设置周一时间对象
      var m_year = monday.getFullYear()
      var m_month = monday.getMonth() + 1
      var m_date = monday.getDate()
      return `${m_year}-${m_month}-${m_date} 00:00:00` // 周一的年月日
    },
    // 跳转日期
    async changeDateView (date) {
      $('#calendar').fullCalendar('gotoDate', date)
      await this.getBookingEventAccodT()
    },
    // 循环遍历bookmark的值
    getBookmarkChooseVal (arr) {
      if (arr.length == 0) return
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].check) this.bookmarkArr.push(arr[i].id)
        if (arr[i].children.length > 0) {
          this.getBookmarkChooseVal(arr[i].children)
        }
      }
    },
    // 切换显示bookmark
    switchShowBF () {
      if (!this.isShow.bookmark) {
        playoutAnalyze(`${googleKey}BookmarkClick`, '/po')
      } else {
        playoutAnalyze(`${googleKey}filterClick`, '/po')
      }
      this.isShow.bookmark = !this.isShow.bookmark
    },
    // 获取与T相关的预约事件  获取事件列表
    async getBookingEventAccodT (ForcedRefresh) {
      this.loadingCalendar = true
      this.ClearMultiple()
      this.DislocationEvent = {}
      if (!this.eventListFlag && !ForcedRefresh) {
        // 上次的还没返回，不去重新请求. 如果强制刷新依旧请求
        return
      }
      this.eventListFlag = false
      try {
        // 获取最近的两个事件
        await this.getRecentEvent()
      } catch (error) {
        console.error(error)
      }
      this.ListQuestRecord++
      const ListQuestRecord = this.ListQuestRecord
      await this.partGetEventAccodT().then((res) => {
        this.loadingCalendar = false
        this.eventListFlag = true
        if (ListQuestRecord < this.ListQuestRecord) {
          return
        }
        // 存一下所有事件
        this.PageAllEvent = res

        if (this.timer.countDown) {
          clearInterval(this.timer.countDown)
          this.timer.countDown = null
          this.countDownTime = '00:00:00'
        }
        this.events = []
        const eventDatas = []
        const data = res
        if (!Array.isArray(data)) {
          return
        }
        $('#calendar').fullCalendar('removeEvents') // 先清空表格
        data.forEach((item, idx) => {
          // 过去的事件不再执行
          const parameters = item.parameters
            ? JSON.parse(item.parameters)
            : {}
          item.source = item.source ? JSON.parse(JSON.stringify(item.source)) : {}
          let bgColor = item.color || 'rgb(255, 192, 0)'

          const eventData = {
            description: item.description || '',
            reporter: parameters.reporter || '',
            title: item.title,
            tname: item.tname,
            rname: item.rname,
            tpeerid: item.tpeerid,
            rpeerid: item.rpeerid,
            type: item.ttype,
            delay: parameters.delay || '',
            bitrate: parameters.bitrate || '',
            url: (item.source && item.source.url) || '',
            // spliceType: item.scte ? item.scte.spliceType : '',
            duration: item.scte ? item.scte.duration : '',
            videoTimes: ['file', 'video'].includes(item.ttype.toLowerCase())
              ? (item.endTime - item.startTime) / 1000
              : '',
            prerollTime: item.scte ? item.scte.prerollTime : '',
            email: item.email,
            userId: item.userId
          }
          const colorName = this.mateColor(bgColor)
          if (item.liveStatus == 1) {
            // 正在执行的事件为green
            bgColor = 'rgb(15, 190, 113)'
            // item.color = 'rgb(15, 190, 113)'
          }
          if (item.liveStatus == 2 || (item.liveStatus == 4 && (item.failedReason == 'Take Next'))) {
            bgColor = '#777777'
            // item.color = '#777777'
          }
          if ((item.liveStatus == 4 && (item.failedReason != 'Take Next')) || item.liveStatus == 5 || item.liveStatus == 6) {
            bgColor = '#8A4B4B'
            // item.color = '#8A4B4B'
          }
          let startTime = this.transitionHourly(new Date(item.startTime))
          let endTime = this.transitionHourly(new Date(item.endTime), 'end')
          // 判断夏令时 0 正常, 1 第二个小时, 2 跨过两个, 3第二个跨到正常
          let isDst = false
          if (this.DstTime.isDst) {
            // 修改夏令时事件的样式
            if ((item.startTime >= this.DstTime.secondDstDate.lastHour && item.startTime < this.DstTime.secondDstDate.startTime) && (item.endTime >= this.DstTime.secondDstDate.startTime && item.endTime < this.DstTime.secondDstDate.endTime)) {
              isDst = 2
              endTime = this.transitionHourly(new Date(this.DstTime.secondDstDate.startTime), 'end')
            }
            if ((item.startTime >= this.DstTime.secondDstDate.startTime && item.startTime < this.DstTime.secondDstDate.endTime) && (item.endTime > this.DstTime.secondDstDate.startTime && item.endTime <= this.DstTime.secondDstDate.endTime)) {
              isDst = 1
            }
            if ((item.startTime >= this.DstTime.secondDstDate.startTime && item.startTime < this.DstTime.secondDstDate.endTime) && item.endTime > this.DstTime.secondDstDate.endTime) {
              isDst = 3
            }
            if (item.multipleModelType) {
              startTime = 'F/O'
            }
            if (item.eventModelType) {
              endTime = this.mode[item.eventModelType]
            }
          }
          const eventInfo = {
            id: item.eventId,
            item,
            eventData,
            title: `${startTime} - ${endTime} ${item.title}`,
            start: $.fullCalendar.moment(this.getRenderingTime('-', item.startTime)),
            end: $.fullCalendar.moment(this.getRenderingTime('-', item.endTime)),
            backgroundColor: bgColor,
            colorName,
            borderColor: '#FFF510',
            className: `livestatus-${item.liveStatus} ${item.eventId} copy_icon draggable_item`,
            startTime: item.startTime,
            endTime: item.endTime,
            liveStatus: item.liveStatus,
            email: item.email,
            userId: item.userId,
            copy: item.copy
          }
          if (isDst == 2 || isDst == 1 || isDst == 3) {
            if (isDst == 1) return
            // 遇到冬令时跨越两个小时，显示时间转换
            const eventInfoStart = JSON.parse(JSON.stringify(eventInfo))
            let ShowStart = this.getRenderingTime('-', item.startTime)
            let ShowEnd = this.getRenderingTime('-', this.DstTime.secondDstDate.startTime - 1)
            if (isDst == 3) {
              ShowStart = this.getRenderingTime('-', this.DstTime.secondDstDate.endTime)
              ShowEnd = this.getRenderingTime('-', item.endTime)
            }
            eventInfoStart.start = $.fullCalendar.moment(ShowStart)
            eventInfoStart.end = $.fullCalendar.moment(ShowEnd)
            eventDatas.push(eventInfoStart)
          } else {
            eventDatas.push(eventInfo)
          }
          // 获取错位事件
          this.getDislocationEvent(item)
          // $('#calendar').fullCalendar('renderEvent', eventInfo, true);        //渲染到表格
        })
        eventDatas.sort((a, b) =>
          // 按开始时间进行排序
          a.startTime - b.startTime
        )
        this.UpdateFirstColor(eventDatas)
        this.events = eventDatas
        this.events.reverse()
        $('#calendar').fullCalendar('renderEvents', this.events, true)
        // 添加DR图标
        this.AddDRicon()
        this.registerDrag()
      })
      // .catch((err) => {
      //   this.eventListFlag = true;
      //   this.loadingCalendar = false;
      // });
    },
    // 分按月按周按日分别查询
    async partGetEventAccodT () {
      try {
        const Timetype = $('#calendar').fullCalendar('getView').name
        let EventList = [] // 事件列表
        const getCurrenTime = this.getCurrenTime()
        if (Timetype == 'agendaWeek') {
          // const _this = this
          const time = getCurrenTime.map((item) => new Date(`${item} ${this.TimeQuantum}:00:00`).getTime())
          this.aheadTimeArr = time
          let type
          if (this.displayType) {
            type = 3
          } else {
            type = 1
          }
          await this.axios
            .all([
              this.GetEventQuest(time[0], time[1] - 1, 3),
              this.GetEventQuest(time[1], time[2] - 1, type),
              this.GetEventQuest(time[2], time[3] - 1, type),
              this.GetEventQuest(time[3], time[4] - 1, type),
              this.GetEventQuest(time[4], time[5] - 1, type),
              this.GetEventQuest(time[5], time[6] - 1, type),
              this.GetEventQuest(
                time[6],
                time[6] + 25 * 60 * 60 * 1000 - 1,
                type
              )
            ])
            .then(
              this.axios.spread((res1, res2, res3, res4, res5, res6, res7) => {
                EventList = EventList.concat(
                  res1.data.result,
                  res2.data.result,
                  res3.data.result,
                  res4.data.result,
                  res5.data.result,
                  res6.data.result,
                  res7.data.result
                )
                this.eventModesList = []
                this.eventModesList.push([...res1.data.result], [...res2.data.result], [...res3.data.result], [...res4.data.result], [...res5.data.result], [...res6.data.result], [...res7.data.result])
                this.dealEventModesList()
              })
            )
        } else if (Timetype == 'agendaDay') {
          const time = new Date(`${getCurrenTime[0]} ${this.TimeQuantum}:00:00`).getTime()
          let type
          if (this.displayType) {
            type = 3
          } else {
            type = 3
          }
          await this.GetEventQuest(time, time + 25 * 60 * 60 * 1000, type).then(
            (res) => {
              EventList = EventList.concat(res.data.result)
              this.eventDayList = []
              this.eventDayList.push(...res.data.result)
              this.dealEventDayList(time)
            }
          )
        } else {
          const monthList = { January: 1, February: 2, March: 3, April: 4, May: 5, June: 6, July: 7, August: 8, September: 9, October: 10, November: 11, December: 12 }
          const title = $('.fc-center h2').html()
          if (!title) return
          const titleArr = title.split(' ')
          const year = titleArr[1]
          const month = monthList[titleArr[0]]
          const MonthStart = new Date(year, month - 1, 1)
          const advance = MonthStart.getDay() == 0 ? 6 : MonthStart.getDay() - 1
          const QueryStart = new Date(year, month - 1, 1).getTime() - advance * 24 * 60 * 60 * 1000
          const TimeQuantum = [
            QueryStart, // 查询月份的起始日期时间戳
            QueryStart + 42 * 24 * 60 * 60 * 1000 // 查询月的结束日期的时间戳
          ]
          await this.GetEventQuest(TimeQuantum[0], TimeQuantum[1]).then((res) => {
            EventList = EventList.concat(res.data.result)
          })
        }
        return EventList
      } catch (error) {
        console.log(error)
        this.$message.error(this.$t('lang.internetOffline'))
        return []
      }
    },
    // 获取事件请求
    GetEventQuest (startTime, endTime, type) {
      // type=0   notCareStart=false notCareEnd=false
      // type=1   notCareStart=false notCareEnd=true
      // type=2   notCareStart=true notCareEnd=false
      // type=3   notCareStart=true notCareEnd=true
      var param = {
        // tId: tId || this.sourceId,
        tid: '',
        rids: [this.selectR.peerId],
        // rIds: '',
        startDate: startTime,
        endDate: endTime
      }
      if (type == 1) {
        param.notCareEnd = true
      } else if (type == 2) {
        param.notCareStart = true
      } else if (type == 3) {
        param.notCareStart = true
        param.notCareEnd = true
      }
      return this.axios({
        method: 'post',
        url: Outil.getUrl('/event/listEventByTR'),
        data: param,
        timeout: 120000,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          isCancelToken: true
        }
      })
    },
    // 获取最近的两个事件
    getRecentEvent () {
      const params = {
        endDate: '15015547523410',
        rids: this.selectR.peerId ? [this.selectR.peerId] : [],
        startDate: -1,
        tid: '',
        notCareStart: true
      }
      return listEvent(params).then((res) => {
        if (res.status == 200 && res.data.errorCode == '0x0') {
          const { result } = res.data
          // 按开始时间进行排序
          result.sort((a, b) => a.startTime - b.startTime)
          this.showEventObj = [result[0], result[1]]
        } else {
          this.showEventObj = []
        }
      }).catch(() => {
        this.showEventObj = []
      })
    },
    // 更新最近一个未播放事件的颜色以及倒计时
    UpdateFirstColor (EventList) {
      let FirstEvent = {}
      const currentTime = new Date().getTime()
      if (this.showEventObj.length > 0) {
        if (this.showEventObj[0] && this.showEventObj[0].startTime > currentTime) {
          FirstEvent = this.showEventObj[0]
        } else if (this.showEventObj[1] && this.showEventObj[1].startTime > currentTime) {
          FirstEvent = this.showEventObj[1]
        }
      }
      // 第一个未执行的事件计时
      if (FirstEvent.id) {
        this.countDownTime = Outil.getIntervalTime(new Date(), FirstEvent.startTime)
        this.nextEvent.rname = FirstEvent.rname
        this.nextEvent.tname = FirstEvent.tname
        this.nextEvent.eventName = FirstEvent.title
        this.timer.countDown = setInterval(() => {
          this.countDownTime = Outil.getIntervalTime(
            new Date(),
            FirstEvent.startTime,
            'ceil'
          )
          if (this.countDownTime == '00:00:00') {
            // 如果next event已经开始,每20秒请求一次事件
            if (this.timeFlag === 0) {
              this.timeFlag = 20
              this.getBookingEventAccodT()
            } else {
              this.timeFlag--
            }
          }
        }, 1000)
      }
      // 第一个非空白未执行的事件修改颜色
      if (FirstEvent.id && EventList.length > 0) {
        for (const v of EventList) {
          if (![1, 5].includes(v.liveStatus) && v.id == FirstEvent.id) {
            if (!(v.backgroundColor === 'rgb(255, 255, 255)' && !v.eventData.tpeerid)) {
              v.backgroundColor = 'rgb(255, 255, 0)'
            }
            break
          }
        }
      }
    },
    // 计算样式
    computedStyle (item, parentItem, type) {
      let EventHeight = 150
      if (type == undefined) {
        EventHeight = $(`.${parentItem.id}`).height()
      } else {
        EventHeight = $(`.${parentItem.id}`).eq(type).height()
      }
      let DSTheight = 0
      // 事件跨夏令时
      if (this.DstTime.isDst) {
        const lastHour = new Date(this.DstTime.firstDstDate.lastHour).getHours()
        const DSTHours = lastHour == 23 ? 0 : lastHour + 1
        if (parentItem.startTime < this.DstTime.firstDstDate.startTime && parentItem.endTime > this.DstTime.firstDstDate.startTime) {
          EventHeight = EventHeight - 300
          DSTheight = 300
          // 跨天且跨夏令时下一半
        } else if (parentItem.startTime == this.DstTime.firstDstDate.startTime && DSTHours == this.TimeQuantum && type) {
          EventHeight = EventHeight - 300
          DSTheight = 300
          // 排除跨天且跨夏令时上一半
        } else if (parentItem.endTime == this.DstTime.firstDstDate.startTime && DSTHours != this.TimeQuantum) {
          EventHeight = EventHeight - 300
        }
      }
      const meanHeight =
        EventHeight / (parentItem.endTime - parentItem.startTime)
      let ScteTop = Math.floor(
        (item.timingIn - parentItem.startTime) * meanHeight
      )
      const ScteHeight = Math.floor(
        (item.timingOut - item.timingIn) * meanHeight
      )
      if (DSTheight && item.timingIn >= this.DstTime.firstDstDate.startTime) {
        ScteTop = ScteTop + DSTheight
      }
      if (item.segmentId == 5) {
        return `height: ${ScteHeight}px;top: ${ScteTop}px;background-color: #388BE5`
      } else if (item.segmentId == 10) {
        return `height: ${ScteHeight}px;top: ${ScteTop}px;background-color: #DA6F17`
      }
      return `height: ${ScteHeight}px;top: ${ScteTop}px`
    },
    // 插入子事件
    InsertionScte (item) {
      if (item.eventSegments.length > 0 && !(item.eventSegments.length == 1 && item.eventSegments[0].segmentId == 1)) {
        const ScteList = item.eventSegments
        const length = $(`.${item.id}`).length
        if (length == 1) {
          let ScteElementWrap = '<div class="ScteListWrap">'
          for (const key in ScteList) {
            if (ScteList[key].segmentId != 1 && ScteList[key].segmentId != 13) {
              const computedStyle = this.computedStyle(ScteList[key], item)
              const ScteWrap = ` <div class="ScteWrap" style="${computedStyle}">
                              </div>`
              ScteElementWrap = ScteElementWrap + ScteWrap
            }
          }
          ScteElementWrap = `${ScteElementWrap}</div>`
          $(`.${item.id}`).prepend(ScteElementWrap)
        } else {
          // 后续有时间会对分段的进行其他操作
          const hour = new Date(item.startTime).getHours()
          const FirstDate = Outil.changeNewDate(item.startTime, 1)
          // 第一天
          let ActualTime = ''
          // 判断是否是第二天
          if (hour < this.TimeQuantum) {
            ActualTime = FirstDate
          } else {
            const SecondTime = new Date(`${FirstDate} 00:00:00`).getTime() + 25 * 60 * 60 * 1000
            const SecondDate = Outil.changeNewDate(SecondTime, 1)
            ActualTime = SecondDate
          }
          const SecondTimeShow = new Date(`${ActualTime} ${this.TimeQuantum}:00:00`).getTime()
          const DoubleEvent = [
            {
              id: item.id,
              startTime: item.startTime,
              endTime: SecondTimeShow
            },
            {
              id: item.id,
              startTime: SecondTimeShow,
              endTime: item.endTime
            }
          ]
          let ScteElementWrap = '<div class="ScteListWrap">'
          let ScteElementWrap1 = '<div class="ScteListWrap">'
          ScteList.forEach((item, index) => {
            if (item.segmentId != 1 && item.segmentId != 13) {
              const ScteItem = item
              if (ScteItem.timingIn <= SecondTimeShow && ScteItem.timingOut <= SecondTimeShow) {
                const computedStyle = this.computedStyle(ScteItem, DoubleEvent[0], 0)
                const ScteWrap = ` <div class="ScteWrap" style="${computedStyle}">
                              </div>`
                ScteElementWrap = ScteElementWrap + ScteWrap
              } else if (ScteItem.timingIn >= SecondTimeShow && ScteItem.timingOut >= SecondTimeShow) {
                const computedStyle = this.computedStyle(ScteItem, DoubleEvent[1], 1)
                const ScteWrap = ` <div class="ScteWrap" style="${computedStyle}">
                              </div>`
                ScteElementWrap1 = ScteElementWrap1 + ScteWrap
              } else {
                const SubeventItem = JSON.parse(JSON.stringify(ScteItem))
                const SubeventItem1 = JSON.parse(JSON.stringify(ScteItem))
                SubeventItem.timingOut = SecondTimeShow
                SubeventItem1.timingIn = SecondTimeShow
                const computedStyle = this.computedStyle(SubeventItem, DoubleEvent[0], 0)
                const ScteWrap = ` <div class="ScteWrap" style="${computedStyle}">
                              </div>`
                const computedStyle1 = this.computedStyle(SubeventItem1, DoubleEvent[1], 1)
                const ScteWrap1 = ` <div class="ScteWrap" style="${computedStyle1}">
                              </div>`
                ScteElementWrap = ScteElementWrap + ScteWrap
                ScteElementWrap1 = ScteElementWrap1 + ScteWrap1
              }
            }
          })
          ScteElementWrap = `${ScteElementWrap}</div>`
          ScteElementWrap1 = `${ScteElementWrap1}</div>`
          $(`.${item.id}`).eq(0).prepend(ScteElementWrap)
          $(`.${item.id}`).eq(1).prepend(ScteElementWrap1)
        }
      }
    },
    // 获取错位事件
    getDislocationEvent (event) {
      if (this.DstTime.isDst && event.startTime && this.TimeQuantum) {
        let eventStartTime = event.startTime
        const eventEndTime = event.endTime
        const startTime = eventStartTime - this.TimeQuantum * 60 * 60 * 1000
        const endTime = eventEndTime - this.TimeQuantum * 60 * 60 * 1000
        if ((startTime >= this.DstTime.firstDstDate.lastHour && startTime < this.DstTime.firstDstDate.startTime) || (endTime >= this.DstTime.firstDstDate.lastHour && endTime < this.DstTime.firstDstDate.startTime)) {
          const TopDate = this.DstTime.firstDstDate.dstDate.split(' ')[0]
          const TopStartTime = new Date(`${TopDate} ${this.TimeQuantum}:00:00`).getTime()
          // 选择两点到两点 跨天又跨夏令时处理
          const lastHour = new Date(this.DstTime.firstDstDate.lastHour).getHours()
          const DSTHours = lastHour == 23 ? 0 : lastHour + 1
          let DSTDeviation = 0
          let DSTBottom = 0
          let DSTTop = 0
          if (DSTHours == this.TimeQuantum) {
            DSTDeviation = 300
            if (eventStartTime < TopStartTime && eventEndTime > TopStartTime) {
              eventStartTime = 0
            }
          } else if (DSTHours > this.TimeQuantum) {
            DSTBottom = 300
            if (eventStartTime >= this.DstTime.firstDstDate.startTime) {
              DSTTop = 300
            }
          }
          let startDuration = (eventStartTime - TopStartTime) / (30 * 60 * 1000)
          startDuration = startDuration < 0 ? 0 : startDuration
          const endDuration = (eventEndTime - TopStartTime) / (30 * 60 * 1000)
          const top = eventStartTime ? startDuration * 150 + DSTDeviation + DSTTop : 0
          const bottom = -(endDuration * 150 + DSTDeviation + DSTBottom)
          this.DislocationEvent[event.id] = {
            top,
            bottom
          }
        }
        const StartScope = this.DstTime.firstDstDate.startTime + 4 * 60 * 60 * 1000
        if ((startTime >= this.DstTime.firstDstDate.lastHour && startTime < StartScope) || (endTime >= this.DstTime.firstDstDate.lastHour && endTime < StartScope)) {
          this.DislocationEvent1[event.id] = true
        }
      }
    },
    // 添加D,R图标 紫色加边框，插入scte
    AddDRicon () {
      // 获取什么视图
      const Timetype = $('#calendar').fullCalendar('getView').name
      this.PageAllEvent.forEach((item) => {
        $(`#calendar .${item.id}`).addClass(`a${item.id}`)
        $(`#calendar .${item.id}`).attr('data-id', item.id)
        $(`#calendar .${item.id}`).attr('draggable', true)
        item.backgroundColor = item.color ? item.color : 'rgb(255, 192, 0)'
        // 插入scte
        if (Timetype == 'agendaDay' || Timetype == 'agendaWeek') {
          const index = $(`.${item.id}`).length > 1 ? 1 : 0
          if (this.DstTime.isDst) {
            if (this.DislocationEvent[item.id] != undefined) {
              const style = this.DislocationEvent[item.id]
              document.getElementsByClassName(item.id)[index].style.inset = `${style.top}px 0% ${style.bottom}px`
            }
            if (this.DislocationEvent1[item.id]) {
              const inset = document.getElementsByClassName(item.id)[index].style.inset.replace('50%', '0%')
              document.getElementsByClassName(item.id)[index].style.inset = inset
            }
          }
          this.InsertionScte(item)
          this.InsertionMetadata(item)
        }
        // 添加冬令时边框
        if (item.daylightSavingTime == 2) {
          $(`#calendar .${item.id}`).css('border', 'solid 5px #068043')
        }
      })
      this.$nextTick(() => {
        if (this.setTime) {
          clearTimeout(this.setTime)
          this.setTime = null
        }
        this.setTime = setTimeout(() => {
          if (Timetype == 'agendaDay') {
            this.PageAllEvent.forEach((item) => {
              $(`.${item.id} .fc-content .fc-title .iconfontWrap`).remove()
              $(`.${item.id} .fc-content .fc-title`).prepend(
                `<div class='iconfontWrap' style=\"position: absolute;right: 0;top: 0; display:flex;padding-right:3px\"></div>
                <div class='HouseID' style=\"position:absolute;top:0px;left:45%\">House ID:${item.houseId ? item.houseId : ''}</div>`
              )
              // 绑定点击事件
              this.monitorClickIcon(
                $(`.${item.id}  ‘.fc-content .fc-title .iconfontWrap`)
              )
              // 判断哪些图标需要
              const iconElement = this.judgeIconNeed(item)
              $(`.${item.id} .fc-content .fc-title .iconfontWrap`).prepend(
                iconElement
              )
              this.IfTimeSourceBlank(item)
            })
          } else {
            this.PageAllEvent.forEach((item) => {
              this.monitorHoverEvent($(`.${item.id}`), item)
              this.IfTimeSourceBlank(item)
            })
          }
        }, 2000)
      })
      // 判断夏令时添加禁用
      this.AddDSTForbidden()
      this.monitorDateClick()
    },
    // 判断时间，source是否空白
    IfTimeSourceBlank (data) {
      let TimeBlack = false
      let sourceBlank = false
      let Point = ''
      if (!data.tpeerid) {
        sourceBlank = true
        $(`#calendar .${data.id}`).css('border', 'solid 3px #FFFFFF')
      } else {
        $(`#calendar .${data.id}`).css('border', 'solid 0px transparent')
      }
      let lastEvent
      data.eventSegments.forEach(item => {
        // 事件scte是否是开始 判断是否是scte类型
        if (item.segmentId == 2 || item.segmentId == 4 || item.segmentId == 11) {
          // 判断scte是否在开始一分钟之内
          this.IsScteStart = data.startTime > (item.timingIn - 60 * 1000)
        }
        if (item.segmentId == 4 || item.segmentId == 5 || item.segmentId == 10 || ((item.segmentId == 2 || item.segmentId == 11) && item.eventOperationType != 'Scte only')) {
          if (!item.sourceId) {
            sourceBlank = true
          }
        }
        if (item.segmentId != 13) {
          lastEvent = item
        }
      })
      if (lastEvent) {
        if (lastEvent.timingOut < data.endTime) {
          TimeBlack = true
        }
      }
      if (TimeBlack && sourceBlank) {
        Point = this.$t('lang.gapSourceBlank')
      } else if (TimeBlack) {
        Point = this.$t('lang.gapPoint')
      } else if (sourceBlank) {
        Point = this.$t('lang.sourceBlank')
      } else {
        Point = ''
      }
      if (Point) {
        const Dom = `
        <div class="SourceBlankPoint">
          <span class="warning" ><i class="iconfont icon-a-eventwarning"></i></span>
          <div class="BlankPoint">${Point}</div>
        </div>`
        $(`.${data.id}`).prepend(Dom)
      }
    },
    // 监听日期点击
    monitorDateClick () {
      try {
        if (this.displayType) return
        $('.fc-head-container .fc-day-header a').on('click', (e) => {
          this.getBookingEventAccodT()
        })
      } catch (error) {
        console.log(error)
      }
    },
    // 判断夏令时添加禁用
    AddDSTForbidden () {
      try {
        if (this.displayType) return
        // 获取什么视图
        const Timetype = $('#calendar').fullCalendar('getView').name
        if (this.DstTime.isDst && (Timetype == 'agendaDay' || Timetype == 'agendaWeek')) {
          const DSTstartTime = this.DstTime.firstDstDate.startTime
          const DSTHour = new Date(DSTstartTime).getHours()
          let DSTDate = Outil.changeNewDate(DSTstartTime, 1)
          // 前一天
          if (DSTHour <= this.TimeQuantum) {
            DSTDate = Outil.changeNewDate(new Date(DSTDate).getTime() - 2 * 60 * 60 * 1000, 1)
          }
          // 夏令时所在那天的开始时间
          const DayStart = new Date(`${DSTDate} ${this.TimeQuantum}:00:00`).getTime()
          const getCurrenTime = this.getCurrenTime()
          const indexStart = getCurrenTime.indexOf(DSTDate)
          const top = (DSTstartTime - DayStart) * (300 / 3600000)
          let WrapWidth = 0
          let right = 0
          if (indexStart == -1) {
            return
          }
          if (Timetype == 'agendaWeek') {
            WrapWidth = ($('.fc-widget-content .fc-slats tr')[0].offsetWidth - 39) / 7
            right = WrapWidth * (6 - indexStart)
          }
          if (Timetype == 'agendaDay') {
            WrapWidth = ($('.fc-widget-content .fc-slats tr')[0].offsetWidth - 39)
            right = 0
          }
          const DaylightDisable = `<div class="DaylightSavingTimeDisable" style="background-color: rgb(108, 34, 34);width: ${WrapWidth}px;height: 300px;position: absolute;z-index: 20000;top: ${top}px;right: ${right}px">
                          <div style="width: 50px;height: 50px;position: absolute;top: 50%;border: 2px solid rgb(224, 34, 34);border-radius: 50%;left: 50%;margin-left: -25px;margin-top: -25px;">
                            <span style="width: 50px;height: 2px;position: absolute;top: 50%;background: rgb(224, 34, 34);transform: rotate(-45deg);"></span>
                          </div>
                    </div>`
          $('.fc-content-skeleton').prepend(DaylightDisable)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 判断哪些图标需要
    judgeIconNeed (item) {
      let LGIconElement = ''
      let CRIconElement = ''
      let DIconElement = ''
      let CCIconElement = ''
      let RIconElement = ''
      let SIconElement = ''
      if (typeof item == 'object') {
        // logo图标
        if (item.logoFlag) {
          LGIconElement = `<p style="width:20px;height:20px;background:${(item.liveStatus == 2 || item.liveStatus == 4) ? '#AAAAAA' : '#AE68F4'};text-align:center;line-height:20px;margin:0px 2px 0px 0px;border-radius: 3px;">
                                <i class='iconfont icon-LG' style="font-size:12px;transform:scale(.8)"></i>
                              </p>
                              `
        }
        // crawl图标
        if (item.crawlFlag) {
          CRIconElement = `<p style="width:20px;height:20px;background:${(item.liveStatus == 2 || item.liveStatus == 4) ? '#AAAAAA' : '#70BDE8'};text-align:center;line-height:20px;margin:0px 2px 0px 0px;border-radius: 3px;">
                                <i class='iconfont icon-CR' style="font-size:12px;transform:scale(.8)"></i>
                              </p>
                              `
        }
        // D图标
        if (item.copy == 'true') {
          DIconElement = `<p style="width:20px;height:20px;background:${(item.liveStatus == 2 || item.liveStatus == 4) ? '#AAAAAA' : '#67AA25'};text-align:center;line-height:20px;margin:0px 2px 0px 0px;border-radius: 3px;">
                                <i class='iconfont icon-duplicate1' style="font-size:12px;transform:scale(.8)"></i>
                              </p>
                              `
        }
        // cc图标
        CCIconElement = `<p style="width:20px;height:20px;background:#AAAAAA;text-align:center;line-height:20px;margin:0px 2px 0px 0px;border-radius: 3px;">
                            <i class='iconfont icon-cc' style="font-size:10px;transform:scale(.7)"></i>
                          </p>
                              `
        //  R图标
        if (item.record) {
          RIconElement = `<p style="width:20px;height:20px;background:${(item.liveStatus == 2 || item.liveStatus == 4) ? '#AAAAAA' : '#EC5050'};text-align:center;line-height:20px;margin:0px 2px 0px 0px;border-radius: 3px;">
                <i class='iconfont icon-secondaryrecord' style="font-size:12px"></i>
              </p>
              `
        } else {
          RIconElement = `<p style="width:20px;height:20px;background:${(item.liveStatus == 2 || item.liveStatus == 4) ? '#AAAAAA' : '#EC5050'};text-align:center;line-height:20px;margin:0px 2px 0px 0px;border-radius: 3px;">
                <i class='iconfont icon-secondaryrecordoff' style="font-size:12px"></i>
              </p>
              `
        }
        // s图标
        SIconElement = `<p style="width:20px;height:20px;background:${(item.liveStatus == 2 || item.liveStatus == 4) ? '#AAAAAA' : '#F2F2F2'};text-align:center;line-height:20px;margin:0px 2px 0px 0px;border-radius: 3px;">
                <i class='iconfont icon-SCTEoff' style="font-size:12px"></i>
              </p>
              `
        return LGIconElement + CRIconElement + DIconElement + CCIconElement + RIconElement + SIconElement
      } else {
        return ''
      }
    },
    // 插入元数据
    InsertionMetadata (event) {
      let Segments = 0
      event && event.eventSegments.forEach((item) => {
        if (item.segmentId == 2 || item.segmentId == 11 || item.segmentId == 4 || item.segmentId == 5 || item.segmentId == 10) {
          Segments = 1
        }
      })
      if (!Segments) {
        const MetadataElement = this.EventMetadata(event)
        $(`.${event.id} .fc-content .Metadata`).remove()
        $(`.${event.id} .fc-content`).append(MetadataElement)
      }
    },
    // 显示事件的一些数据
    EventMetadata (event) {
      let series = ''
      let episodeTitle = ''
      let season = ''
      let episode = ''
      if (this.displayEventMetadata.includes('series') && event.series != null) {
        series = `<div class="Series">${event.series}</div>`
      }
      if (this.displayEventMetadata.includes('episodeTitle') && event.episodeTitle != null) {
        episodeTitle = `<div class="EpisodeTitle">${event.episodeTitle}</div>`
      }
      if (this.displayEventMetadata.includes('season') && event.season != null) {
        season = `<div class="Season">${this.$t('lang.Season')}: ${event.season}</div>`
      }
      if (this.displayEventMetadata.includes('episode')) {
        if (event.episode === null) {
          event.episode = ''
        }
        episode = `<div class="Episode">${this.$t('lang.Episode1')}:${event.episode}</div>`
      }
      const SeasonEpisode = `<div class="SeasonEpisode">${season}${episode}</div>`
      return `<div class="Metadata">${series}${episodeTitle}${SeasonEpisode}</div>`
    },
    // 监听图标点击事件
    monitorClickIcon (item) {
      item.click((event) => {
        this.IsClickIcon = true
      })
    },
    // 监听hover事件
    monitorHoverEvent (element, item) {
      element.hover((event) => {
        // 鼠标进入事件
        if (event.type == 'mouseenter') {
          const IconElement = this.judgeIconNeed(item)
          const BoxPosition = {
            top: event.clientY,
            left: event.clientX,
            bottom: document.documentElement.clientHeight - event.clientY,
            right: document.documentElement.clientWidth - event.clientX
          }
          let PositionClass = ''
          if (BoxPosition.top < 300) {
            PositionClass = ' eventActiveBoxBottom'
          }
          if (BoxPosition.right < 250) {
            PositionClass = `${PositionClass} eventActiveBoxRight`
          }
          const startTime = Outil.changeNewTime(item.startTime)
          const endTime = Outil.changeNewTime(item.endTime)
          const MetadataElement = this.EventMetadata(item)
          const DomElement = `
                <div class="eventActiveBox${PositionClass}">
                  <div class="eventMessageBox" style="background:${item.backgroundColor}">
                    <div class="eventMessageTop">
                      <p class="eventMessageTitle">${startTime}-${endTime} ${item.title}</p>
                      <div class='iconfontWrap'>
                        ${IconElement}
                      </div>
                    </div>
                    ${MetadataElement}
                  </div>
                    <i class="el-icon-caret-bottom" style='color:${item.backgroundColor};'></i>
                    <i class="el-icon-caret-top" style='color:${item.backgroundColor};'></i>
                </div>
                `
          element.css('z-index', 2)
          element.prepend(DomElement)
          // 绑定点击事件
          this.monitorClickIcon(element.find('.eventActiveBox .iconfontWrap'))
        } else {
          //  鼠标离开事件
          element.css('z-index', 1)
          element.children('.eventActiveBox') &&
            element.children('.eventActiveBox').remove()
        }
      })
    },
    // 获取当前时间
    getCurrenTime () {
      const timeEle = $('.fc-head-container .fc-day-header')
      const timeArr = []
      timeEle.map((i, v) => {
        const time = $(v).attr('data-date')
        timeArr.push(time && time.replace(/-/g, '/'))
        return 1
      })
      return timeArr
    },
    // 找到color对应的颜色或值
    mateColor (color) {
      const colorObj = {
        green: 'rgb(15, 190, 113)',
        skyblue: 'rgb(70, 201, 225)',
        blue: 'rgb(14,107,209)',
        orange: 'rgb(255, 197, 115)',
        pink: 'rgb(255, 106, 146)',
        yellow: 'rgb(255, 192, 0)',
        purple: 'rgb(146, 72, 199)'
      }
      for (const key in colorObj) {
        if (color == key) {
          return colorObj[key]
        }
        if (color == colorObj[key]) {
          return key
        }
      }
    },
    // 转换splice type
    transformSpliceType (val) {
      let type
      switch (val) {
        case '0':
          type = 'Start Normal'
          break
        case '1':
          type = 'Start Immediate'
          break
        case '2':
          type = 'End Normal'
          break
        case '3':
          type = 'End Immediate'
          break
        case '4':
          type = 'Cancel'
          break
        default:
          break
      }
      return type
    },
    // 小屏下切换source列表是否显示
    toggleSource (e) {
      if (document.body.clientWidth > 1024) {
        return
      }
      e.stopPropagation()
      this.isShow.sourceList = !this.isShow.sourceList
    },
    // 小屏下切换r列表是否显示
    toggleR (e) {
      if (document.body.clientWidth > 1024) {
        return
      }
      e.stopPropagation()
      this.isShow.rList = !this.isShow.rList
    },
    todayDate () {
      const nowDate = new Date()
      const year = nowDate.getFullYear()
      let month = nowDate.getMonth() + 1
      let day = nowDate.getDate()
      if (month < 10) month = `0${month}`
      if (day < 10) day = `0${day}`
      return `${year}-${month}-${day}`
    }
  },
  computed: {
    ...mapState({
      CloneDisabled: (state) => state.playout.CloneDisabled,
      // 多选选中的文件夹
      PitchOnFileList: (state) => state.playout.PitchOnFileList,
      // ctrl+c 复制的事件
      CtrlCopyEvent: (state) => state.playout.CtrlCopyEvent,
      // 高级配置的某些参数
      AdvancedSetupConfig: (state) => state.playout.AdvancedSetupConfig
    }),
    // 视图切换按钮
    // viewBtns() {
    //     return
    // },
    // 日历渲染
    eventSources () {
      const self = this
      return [
        {
          events (start, end, timezone, callback) {
            self.$nextTick(() => {
              callback(self.events.filter((v) => 0))
            })
          }
        }
      ]
    },
    // 计算source列表高度
    sListBoxHeight () {
      if (this.calendar.searchS) {
        return 'calc(100% - 100px)'
      }
      if (this.calendar.filterBox) {
        return 'calc(100% - 410px)'
      }
      return 'calc(100% - 50px)'
    },
    // 计算r列表高度
    rListBoxHeight () {
      if (this.calendar.searchR) {
        return 'calc(100% - 100px)'
      }
      return 'calc(100% - 50px)'
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
    Bus.$off('leftListUpdate', this.registerDrag)
    Bus.$off('clickSearchResult')
    Bus.$off('jumpDesignatedEvent')
    Bus.$off('changeSchedulerModes')
    console.warn('websocket-calendarSche')
    document.removeEventListener('keydown', this.Onkeydown)
    // document.getElementById('listenRightClick').removeEventListener('contextmenu', this.OnRightClick)
    // 监听松开鼠标
    document.removeEventListener('mouseup', this.OnLeftClick)
  }
}
</script>
<style lang='less' scoped>
@import '~fullcalendar/dist/fullcalendar.css';
.CreateTemplate {
  float: right;
  width: calc(100% - 600px);
}
.ProgramTemplateEdit {
  float: right;
  width: calc(100% - 600px);
  height: 100%;
}
.el-dialog {
  width: 30%;
}
p {
  margin: 0;
}
input {
  outline: none;
}
.forbid ::v-deep .el-input__inner {
  cursor: not-allowed;
}
// ::-webkit-scrollbar {
//   /*滚动条整体样式*/
//   width: 0; /*高宽分别对应横竖滚动条的尺寸*/
// }
// ::-webkit-scrollbar-thumb {
//   /*滚动条里面小方块*/
//   border-radius: 5px;
//   background-color: rgb(233, 233, 233);
//   opacity: 0.7;
// }
// ::-webkit-scrollbar-track {
//   /*滚动条里面轨道*/
//   border-radius: 5px;
//   background: none;
// }
.show_height {
  height: 170px;
}
ul {
  margin-bottom: 0;
}
.green {
  border: 1px solid #0a9a5a;
  background: #0fbe71;
}
.skyblue {
  background-color: #46c9e1;
  border: 1px solid #0ca595;
}
.blue {
  background-color: #2f8df4;
  border: 1px solid #126ed3;
}
.orange {
  background-color: #ffc573;
  border: 1px solid #d8a966;
}
.pink {
  background-color: #ff6a92;
  border: 1px solid #ee3656;
}
.yellow {
  background-color: #ffc000;
  border: 1px solid #ffc000;
}
.purple {
  background-color: #9248c7;
  border: 1px solid #9248c7;
}
.calendar {
  min-height: 850px;
  height: 100%;
  background: #444;
  display: flex;
  .gray {
    color: #666 !important;
    input {
      color: #666 !important;
    }
  }
  .calendarLeft {
    width: 600px;
    min-height: 850px;
    height: 100%;
    // overflow: hidden;
    float: left;
  }
  .device_list {
    position: absolute;
    width: 520px;
    // width: 260px;
    height: 100%;
    float: left;
    // margin-bottom: 30px;
    background: #444;
    .r_title {
      padding-right: 30px;
    }
    .create_info {
      width: 150%;
      font-size: 10px;
      text-align: left;
      height: 50px;
      margin-left: 18px;
      line-height: 48px;
      position: relative;
      .selectR {
        position: absolute;
        right: -270px;
        z-index: 1000;
        .tips {
          width: 30%;
          font-size: 0.14rem;
          font-weight: bold;
          text-align: left;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .selectRMain {
          width: 70%;
          height: 30px;
          background: #333;
          margin-top: 10px;
          line-height: 30px;
        }
        ::v-deep .el-input__inner {
          width: 100%;
          height: 30px;
          top: 0;
        }
        ::v-deep .el-input__inner::placeholder {
          color: rgba(108, 108, 108, 1);
        }
        ::v-deep .arrow-icon {
          top: 9px;
        }
        ::v-deep .el-select-dropdown {
          max-width: 203px;
          left: 0 !important;
        }
      }
      .iconfont {
        font-size: 15px;
      }
      .title_text {
        margin: 0 5px;
        color: #999;
      }
      .create_info_cont {
        // width: calc(100% - 85px);
        width: calc(100% - 70px);
        span {
          width: 25%;
          padding: 0 5px;
          line-height: 50px;
        }
        span:last-child {
          width: 35%;
        }
      }
      // .r_down_list {
      //     position: absolute;
      //     top: 0;
      //     right: -300px;
      //     background: #252525;
      //     ::v-deep .selectSource .el-input__inner {
      //         background-color: #252525;
      //     }
      // }
    }
    .device_content {
      height: calc(100% - 50px);
      border-bottom: 1px solid #000;
      border-top: 1px solid #000;
    }
    .source_list {
      // .r_list {
      // width: 50%;
      width: 100%;
      height: 100%;
      border-right: 1px solid #000;
      font-size: 18px;
      text-align: left;
      box-sizing: border-box;
      float: left;
    }
    // .r_list {
    //     // border: none;
    // }
    .device_title {
      height: 50px;
      line-height: 50px;
      background-color: #555;
      padding-left: 20px;
      padding-right: 10px;
      i {
        font-size: 23px;
      }
      .icon-filter {
        font-size: 20px;
        margin: 0 10px;
        padding-left: 10px;
      }
      .icon-filter:before {
        content: '\e61c';
      }
    }
    .search_ipt {
      height: 50px;
      line-height: 50px;
      background: #aaa;
      color: #eee;
      outline: none;
      input {
        height: 50px;
        background: transparent;
        border: none;
        width: 80%;
        padding-left: 14px;
        font-size: 16px;
      }
      i {
        font-size: 23px;
        margin-right: 5%;
      }
      i.down_arrow {
        display: none;
      }
    }
    .filter_box {
      height: 360px;
      background: #aaa;
      padding: 10px 0;
      ::v-deep .el-checkbox .el-checkbox__inner {
        background: #fff;
      }
      .filter_item {
        margin: 0 auto;
        width: 90%;
        height: unset;
        background: #444;
        border-radius: 5px;
        .item_title {
          border-radius: 5px;
          height: 45px;
          line-height: 45px;
          padding-left: 10px;
          background: #616161;
          color: #aaa;
          font-size: 14px;
        }
        .item_title.active {
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          // .el-icon-caret-bottom {
          //     transform: rotate(-180deg);
          // }
        }
        // .pull_down {
        //     position: absolute;
        //     right: 15px;
        //     top: 50%;
        //     transform: translateY(-50%);
        // }
        .el-icon-caret-bottom {
          color: #fff;
          font-size: 22px;
          line-height: 45px;
          margin-right: 15px;
          transition: 0.3s;
        }
      }
      .item_content {
        margin: 0 auto;
        width: 90%;
        height: 235px;
        line-height: 30px;
        background-color: #444;
        // margin-bottom: 10px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        font-size: 12px;
      }
    }
    .list_box {
      font-size: 16px;
      li {
        height: 50px;
        line-height: 50px;
        padding-left: 24px;
        max-width: 250px;
        box-sizing: content-box;
        span {
          position: relative;
          z-index: 1;
        }
      }
    }
  }
  .magnifying {
    float: left;
    width: 80px;
    min-height: 800px;
    height: calc(100% - 50px);
    margin-top: 50px;
    overflow: hidden;
    border-top: 1px solid #000;
    .header{
      height: 50px;
      border-bottom: 1px solid #333;
    }
    .body {
      width: 100%;
      height: calc(100% - 55px);
      overflow-y: scroll;
    }
    .mnf_btn {
      width: 100%;
      height: 150px;
      /*margin-top: 5px;*/
      /*border-bottom: 1px solid #333;*/
    }
    button {
      width: 55px;
      height: 20px;
      border-radius: 3px;
      background: #333;
      border: 1px solid #444;
      font-size: 12px;
    }
  }
  .calendar_box_save {
    // width: calc(100% - 520px);
    width: 400px;
    position: absolute;
    right: 0px;
    // left: 520px;
    left: 600px;
    top: 100px;
    z-index: 3000;
    // left: 340px;
    height: 177px;
    background: #444;
    padding: 51px 0 0 17px;
    text-align: left;
  }
  .tableSaveFooter {
    position: absolute;
    right: 0px;
    bottom: 0px;
    /* top: 100px; */
    left: 518px;
    background: #444;
    z-index: 2000;
  }
  .calendar_box {
    width: calc(100% - 680px);
    position: relative;
    // position: absolute;
    // right: 0px;
    // left: 515px;
    height: 100%;
    // overflow: hidden;
    background: #444;
    .tableSaveFooter {
      position: absolute;
      right: 0px;
      bottom: 0;
      left: 600px;
    }
    .count_down {
      width: 280px;
      height: 36px;
      line-height: 36px;
      color: rgb(255, 192, 0);
      visibility: hidden;
      border: 1px solid #ccc;
      margin-top: 5px;
      padding: 0 10px;
      border-radius: 5px;
      position: absolute;
      left: 1px;
      span {
        width: 25%;
      }
    }
    .count_down.visib {
      visibility: visible;
    }
    ::v-deep .fc-more-popover {
      max-height: 200px;
      overflow: scroll;
    }
    // cal_date_opt
    ::v-deep .date_option .el-input__inner {
      border: none;
      background-color: transparent;
      color: transparent;
    }
    ::v-deep .fc-unthemed {
      th,
      td,
      thead,
      tbody,
      .fc-divider,
      .fc-row,
      .fc-content,
      .fc-popover,
      .fc-list-view,
      .fc-list-heading td {
        border-color: #333;
      }
    }
    ::v-deep .fc-toolbar.fc-header-toolbar {
      padding-right: 80px;
      margin-bottom: 0;
      height: 50px;
    }
    ::v-deep .fc-unthemed .fc-head-container.fc-widget-header {
      border-top-color: #000;
    }
    ::v-deep .fc-right .fc-button-group {
      width: 230px;
      height: 28px;
      line-height: 28px;
      border-radius: 4px;
      overflow: hidden;
      // background-color: #666;
      text-align: center;
      cursor: pointer;
      margin-top: 10px;
      button {
        float: left;
        width: 33.3%;
        height: 100%;
        border-right: 1px solid #999;
        background: #666;
        color: #fff;
        border: none;
        text-shadow: none;
      }
      ::v-deep .fc-state-active {
        background: #999;
        border-top: none;
      }
    }
    ::v-deep .fc-toolbar.fc-header-toolbar {
      padding-right: 80px;
      .fc-center {
        position: relative;
        width: 250px;
        > div {
          width: 100%;
          h2 {
            text-align: center;
          }
          button {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background-color: #444;
            background-image: none;
            box-shadow: none;
            text-shadow: none;
            border: none;
            .fc-icon {
              font-size: 17px;
              color: #fff;
              font-weight: normal;
            }
          }
          .fc-prev-button {
            left: 0;
          }
          .fc-next-button {
            right: 0;
          }
        }
      }
    }
    ::v-deep .fc-event,
    .fc-event-dot {
      background-color: rgb(15, 190, 113);
      border: none;
    }
    ::v-deep .fc-time-grid-event.fc-short .fc-time span {
      display: inline;
    }
    ::v-deep .fc-time-grid-event.fc-short .fc-time::before,
    ::v-deep .fc-time-grid-event.fc-short .fc-time::after {
      content: '';
    }
  }
  .calendar_list{
     width: calc(100% - 600px);
  }
  ::v-deep .create_booking {
    position: absolute;
    width: 4rem;
    height: 3rem;
    // background-color: rgba(201, 201, 201, 1);
    // background-color: #dcdcdc;
    background-color: #252525;

    border-radius: 4px;
    z-index: 2038;
    padding: 0.16rem;
    padding-right: 0.2rem;
    color: #999;
    font-size: 0.16rem;
    box-sizing: border-box;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.78);
    .create_title {
      margin-bottom: 15px;
      .separator {
        padding: 0 10px;
      }
      li.active {
        // color: #000;
        color: #33ab4f;
      }
      .event_color {
        width: 20px;
        height: 20px;
        // background: rgb(15, 190, 113);
        margin-right: 10px;
        border: none;
      }
      .event_title {
        text-align: left;
        font-size: 16px;
        // color: #000;
        width: 80%;
      }
    }
    .event_content_detail {
      font-size: 12px;
      // color: #000;
      .detail_item {
        height: 32px;
        line-height: 32px;
        border-bottom: 1px solid rgba(153, 153, 153, 1);
        padding: 0 10px;
        margin-bottom: 0;
        span:first-child {
          color: #666;
        }
        span:nth-child(2) {
          width: 78%;
          text-align: right;
        }
        .SCTESelet {
          display: flex;
          align-items: center;
          justify-content: space-between;
          p {
            text-align: left;
            font-size: 12px;
            color: #666666;
            margin-right: 20px;
          }
          .el-input__inner {
            border: none;
            color: #999;
            font-size: 12px;
            width: 165px;
            text-align: right;
          }
        }
      }
      margin-bottom: 10px;
    }
    .c_itemdetail {
      //   margin-bottom: 10px;
      background-color: #444;
      color: #999;
      display: flex;
      padding: 10px 0 0 0;
      font-size: 12px;
      //  justify-content: space-around;
      .c_itemdetail_item {
        width: 27%;
      }
      .c_itemdetail_items {
        width: 30%;
        float: left;
        margin-left: 20%;
      }
    }
    .c_itemdetails {
      font-size: 12px;
      margin-bottom: 10px;
      background-color: #444;
      color: #999;
      .c_itemdetail_item {
        width: 16%;
      }
    }
    .c_item {
      height: 30px;
      margin-bottom: 10px;
      input {
        width: 310px;
        height: 30px;
        // background-color: rgba(228, 228, 228, 1);
        background-color: #444;
        // color: #000;
        color: #999;
        // border: 1px solid rgba(153,153,153,1);
        border: none;
        border-radius: 4px;
        text-indent: 10px;
        font-size: 12px;
        box-sizing: border-box;
      }
      .time_opt {
        width: 170px;
        height: 30px;
        // line-height: 30px;
        line-height: 26px;
        color: #000;

        background: rgba(228, 228, 228, 1);
        // border: 1px solid rgba(153, 153, 153, 1);
        border: none;
        border-radius: 4px;
        .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 100%;
        }
        input.el-input__inner {
          width: 100%;
          background: #444;
          padding: 0;
          border: none;
          // line-height: 26px;
        }
        .el-input__prefix,
        .el-input__suffix-inner {
          display: none;
        }
      }
    }
    .RecordSelete {
      height: 20px;
    }
    .SCTESelet {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #444;
      height: 30px;
      border-radius: 4px;
      padding-left: 12px;
      margin-bottom: 10px;
      p {
        text-align: left;
        font-size: 12px;
        color: #666666;
        margin-right: 20px;
      }
      .el-input__inner {
        border: none;
        color: #999;
        font-size: 12px;
        width: 170px;
        text-align: right;
      }
    }
    .des.c_item {
      height: 60px;
      margin-bottom: 0px;
      textarea {
        resize: none;
      }
    }
    .note {
      .color_box {
        height: 100%;
        padding-right: 22px;
      }
      .color_opt {
        width: 255px;
        height: 40px;
        // background: #fff;
        background: #333;
        color: #999;
        border-radius: 4px;
        position: absolute;
        right: -11px;
        top: 31px;
        padding: 10px 0;
        padding-left: 6px;
        font-size: 12px;
        line-height: 20px;
        z-index: 10000;
        li {
          width: 20px;
          height: 20px;
          cursor: pointer;
          margin-left: 10px;
        }
      }
      .color_opt.triangle:before {
        left: 196px;
      }
      .color {
        width: 20px;
        height: 20px;
        margin-left: 10px;
        margin-top: 4px;
        box-sizing: content-box;
      }
      .el-icon-caret-bottom {
        font-size: 20px;
        position: absolute;
        top: 16%;
        right: 0px;
        transform: translateY(-50%);
        transform: rotate(0deg);
        transition: 0.3s;
      }
      .el-icon-caret-bottom.top {
        transform: rotate(-180deg);
      }
      .to {
        // color: #000;
        color: #999;
        margin-left: 7px;
        line-height: 30px;
        font-size: 12px;
      }
      .reporter,
      textarea {
        width: 367px;
        // border: 1px solid rgba(153, 153, 153, 1);
        border: none;
      }
      textarea {
        // background: rgba(228, 228, 228, 1);
        background: #444;
        border-radius: 4px;
        height: 60px;
        // color: #000;
        color: #999;

        font-size: 12px;
        line-height: 15.6px;
        padding: 2px 2px 2px 10px;
        box-sizing: border-box;
      }
    }
    .create_footer {
      margin-top: 15px;
      button {
        width: 86px;
        height: 30px;
        background: #999;
        color: #fff;
        border: none;
        border-radius: 4px;
        font-size: 12px;
      }
      .save,
      .edit {
        background-color: #0c6;
        margin-left: 10px;
      }
      .delete {
        width: 72px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid rgba(153, 153, 153, 1);
        background: transparent;
        // color: #333;
      }
      .copy {
        margin-left: 100px;
        color: #39aa50;
        border: 1px solid #39aa50;
        background: transparent;
      }
      .end_live {
        background: #f00;
        color: #fff;
      }
    }
    .device {
      color: rgb(102, 102, 102);
      margin: 0 9px;
      .d_item {
        width: 100%;
        height: 32px;
        line-height: 32px;
        border-bottom: 1px solid rgba(153, 153, 153, 1);
        font-size: 12px;
        padding: 0 20px 0 10px;
        .val {
          color: #999;
          width: 56%;
          text-align: right;
        }
        .ipt {
          float: right;
          height: 25px;
          width: 135px;
          margin-top: 3px;
          margin-right: -20px;
          border: none;
          padding-left: 10px;
          padding-right: 20px;
          box-sizing: border-box;
          color: #999;
          background-color: transparent;
          text-align: right;
        }
        .scte_ipt {
          color: #000;
        }
        .delay.active,
        .bitrate.active {
          text-align: left;
          background-color: #fff;
          color: #333;
        }
        .triangle:before {
          top: 60%;
          left: 95%;
          transform: translateY(-50%);
          border-color: transparent;
          border-top-color: #999;
          border-width: 6px;
          transition: 0.3s;
        }
        .triangle.up:before {
          top: 23%;
          transform: rotate(-180deg);
        }
        .createbox_r_list {
          position: absolute;
          right: 0;
          top: 32px;
          background: #ababab;
          width: 2.2rem;
          height: 170px;
          text-align: left;
          color: #333;
          li {
            padding-left: 10px;
            height: 32px;
            line-height: 32px;
            box-sizing: border-box;
            font-size: 12px;
          }
          li:hover {
            background: rgba(0, 208, 105, 0.2);
          }
          .el-scrollbar__thumb {
            background: #fff;
          }
        }
      }
      .d_item.source {
        input {
          float: right;
          border: none;
          height: 25px;
          width: 100px;
          padding-left: 10px;
          padding-right: 25px;
          margin-right: -20px;
          margin-top: 3px;
          box-sizing: content-box;
          color: #000;
        }
      }
    }
  }
  ::v-deep .create_booking.triangle:before {
    border-top-color: #dcdcdc;
    border-right-color: #dcdcdc;
    border-bottom-color: transparent;
    left: 0.6rem;
    top: -0.095rem;
    border-width: 12px;
    box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.38);
    transform: rotate(-45deg);
  }
  ::v-deep .create_booking.right.triangle:before {
    left: 3.15rem;
  }
  ::v-deep .create_booking.bottom.triangle:before {
    top: 3.35rem;
    transform: rotate(135deg);
  }
  ::v-deep .create_booking.bottom.device.triangle:before {
    top: 2.46rem;
  }
  ::v-deep .el-checkbox .el-checkbox__inner {
    background: transparent;
  }
  ::v-deep .el-checkbox .el-checkbox__inner::after {
    border-color: #33ab4f;
    left: 4px;
    top: 0;
  }
  ::v-deep .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
    background: #fff;
    border-color: transparent;
  }
  ::v-deep .el-checkbox__inner:hover {
    border-color: #fff;
  }
  ::v-deep .el-checkbox__input.is_focus {
    border-color: #fff;
  }
  ::v-deep .el-checkbox .el-checkbox__input.is-checked + .el-checkbox__label {
    font-size: 12px;
  }
  ::v-deep .el-checkbox .el-checkbox__inner {
    width: 15px;
    height: 15px;
  }
  ::v-deep .el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: transparent;
  }
  ::v-deep .el-checkbox__label {
    font-size: 12px;
  }
  ::v-deep .el-checkbox {
    display: block;
    margin: 0;
    padding-left: 8px;
    height: 24px;
    line-height: 24px;
    margin-bottom: 6px;
  }
  ::v-deep .el-checkbox:hover {
    background-color: rgba(57, 170, 80, 0.25);
  }
  ::v-deep .item_content.pointer div {
    margin: 0 !important;
  }
}
::v-deep .cal_date_opt {
  // margin-left: 20%;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  margin-left: -162px;
  i {
    font-size: 18px;
  }
  .el-input__suffix,
  .el-input__prefix {
    display: none;
  }
  ::v-deep .el-date-editor input {
    color: transparent;
  }
  .icon-save{
    font-size:35px;
    margin-left:10px;
  }
  .icon-clear{
    margin-left:5px;
    vertical-align: middle;
    font-size:17px;
  }
}
::v-deep .replace_title {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  width: 100%;
  font-size: 16px;
  color: #fff;
}
// ::v-deep .el-input__inner {
//   background-color: transparent;
//   z-index: 1000;
//   position: relative;
//   // color: transparent;
//   cursor: pointer;
// }
::v-deep #calendar .fc-center {
  visibility: hidden;
  display: none;
}
::v-deep #calendar .fc-header-toolbar {
  margin-bottom: 0;
}
::v-deep .fc-time-grid-event.fc-helper {
  overflow: visible;
}
::v-deep .el-popper[x-placement^='top'] .popper__arrow:after {
  background: #fff;
}
::v-deep .calendar .calendar_box .fc-unthemed th {
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  background: #555;
  // color: #fff;
  color: #ccc;
  font: 400 normal 14px/50px 'Microsoft yahei';
}
::v-deep .fc-axis {
  padding-right: 0px;
  padding-left: 3px;
}
::v-deep .fc-axis.fc-widget-header,
::v-deep .fc-axis.fc-time.fc-widget-content {
  width: 39px !important;
  box-sizing: border-box;
  text-align: center;
}
::v-deep .fc-unthemed td.fc-today {
  background-color: #666;
}
::v-deep .fc-time-grid .fc-slats td {
  height: 150px;
  box-sizing: border-box;
}
::v-deep .fc-axis.fc-time.fc-widget-content span {
  font-size: 12px;
}
::v-deep .antline {
  // position: relative;
  background-color: #3f5d46 !important;
  padding: 2px;
  background-image: -webkit-linear-gradient(
    -45deg,
    rgba(16, 180, 103, 1) 25%,
    rgba(16, 180, 103, 0) 25%,
    rgba(16, 180, 103, 0) 50%,
    rgba(16, 180, 103, 1) 50%,
    rgba(16, 180, 103, 1) 75%,
    rgba(16, 180, 103, 0) 75%,
    rgba(16, 180, 103, 0)
  );
  background-size: 10px 10px;
  animation: antline 0.8s linear infinite;
  box-sizing: content-box;
}
::v-deep .fc-title {
  color: #333;
}
::v-deep .antline::after {
  position: absolute;
  top: 2px;
  left: 2px;
  bottom: 2px;
  right: 2px;
  display: block;
  content: '';
  background-color: #3f5d46;
}
@keyframes antline {
  0% {
    background-position: 0px 0px;
  }
  50% {
    background-position: 0px 5px;
  }
  100% {
    background-position: 0px 10px;
  }
}
@media (max-width: 1680px) {
  .calendar {
    .calendarLeft {
      width: 450px;
    }
    .calendar_box {
      width: calc(100% - 530px);
    }
    .calendar_list{
        width: calc(100% - 450px);
    }
    .CreateTemplate,.ProgramTemplateEdit{
      width: calc(100% - 359px);;
    }
  }
}

@media (max-width: 1480px) {
  .calendar {
    .calendarLeft {
      width: 360px;
    }
    .calendar_box {
      width: calc(100% - 440px);
    }
    .calendar_list{
        width: calc(100% - 360px);
    }
    .CreateTemplate,.ProgramTemplateEdit{
      width: calc(100% - 359px);;
    }
  }
  // .calendar_box {
  //   .count_down {
  //     position: absolute;
  //     left: -280px;
  //   }
  // }
}
@media (max-width: 1330px) {
  .calendar {
    .calendarLeft {
      width: 324px;
    }
    .calendar_box {
      width: calc(100% - 404px);
    }
    .calendar_list{
      width: calc(100% - 324px);
    }
    .CreateTemplate,.ProgramTemplateEdit{
      width: calc(100% - 324px);;
    }
  }
  .calendar .calendar_box {
    .count_down {
      width: 180px;
    }
  }
}
@media (max-width: 1280px) {
  .calendar {
    width: 1280px;
    .calendar_box {
      width: 870px;
    }
    .calendar_list{
      width: 956px;
    }
  }
}

::v-deep .fc-time-grid-event.fc-event .fc-content .fc-time,
::v-deep .fc-day-grid-event.fc-h-event.fc-event .fc-content .fc-time {
  display: none;
}
::v-deep .fc-time-grid-event.fc-event.fc-helper.antline .fc-content .fc-time {
  display: block;
}
::v-deep .fc-widget-content .fc-content-col .fc-content {
  width: 100%;
}
::v-deep .fc-widget-content .fc-event .fc-content .fc-title {
  width: 99%;
  overflow: hidden;
  // white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
  // float: left;
}
::v-deep .fc-agendaDay-view .fc-widget-content .fc-event .fc-content .fc-title {
  width: 42%;
}
::v-deep .fc-widget-content .fc-event .fc-content .el-icon-document-copy {
  margin-right: 3px;
  margin-top: 3px;
  display: none;
  color: #333;
}
::v-deep .fc-widget-content .fc-event .fc-content:hover .el-icon-document-copy {
  display: block;
}
::v-deep a.fc-event.fc-draggable {
  min-height: 1px;
}
::v-deep .fc-popover .fc-header {
  color: #333;
}
::v-deep.recordInput {
  .el-checkbox__inner {
    background: #ffffff !important;
  }
}
.calendar {
  .calendar_box {
    .calendarEventWrap {
      ::v-deep ::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      ::v-deep ::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 5px;
        background-color: rgb(233, 233, 233);
        opacity: 0.7;
      }
      ::v-deep ::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 5px;
        background: none;
      }
      ::v-deep .purpleEvent {
        overflow: visible;
      }
      ::v-deep .purpleEvent::after {
        content: '';
        border-width: 5px 10px;
        border-style: solid;
        border-color: transparent rgba(255, 255, 255) transparent transparent;
        position: absolute;
        top: -5px;
        right: -10px;
      }
      ::v-deep .purpleEvent::before {
        content: '';
        border-width: 5px 10px;
        border-style: solid;
        border-color: transparent transparent transparent rgba(255, 255, 255);
        position: absolute;
        bottom: -5px;
        right: -20px;
      }
      ::v-deep .fc-time-grid-event .fc-content {
        overflow: hidden;
        height: 100%;
        position: relative;
        z-index: 1001;
        padding-left: 10px;
        padding-right: 5px;
        box-sizing: border-box;
      }
      ::v-deep .fc-time-grid .fc-event-container {
        z-index: auto;
      }
      ::v-deep .fc-event {
        overflow: visible;
        .Metadata {
          color: #252525;
          font-size: 12px;
          font-weight: 400;
          letter-spacing: 0px;
          .SeasonEpisode {
            display: flex;
            .Season {
              margin-right: 5px;
            }
          }
        }
        .eventActiveBox {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 150%;
          z-index: 100000000000;
          padding-bottom: 11px;
          transform: translateY(-100%);
          .eventMessageBox {
            box-shadow: 0px 2px 4px 2px rgba(0, 0, 0, 0.5);
            border-radius: 3px;
            padding: 8px 10px;
            text-align: left;
            .eventMessageTop {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .eventMessageTitle {
                width: 70%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin: 0;
                color: #252525;
                font-size: 14px;
              }
              .iconfontWrap {
                height: 30px;
                display: flex;
                align-items: center;
                padding-right: 3px;
                position: absolute;
                right: 0;
                top: 0;
                i {
                  color: #333;
                }
              }
            }
            .Metadata {
              color: #252525;
              font-size: 14px;
              font-weight: 400;
              line-height: 17px;
              letter-spacing: 0px;
              .SeasonEpisode {
                display: flex;
                .Season {
                  margin-right: 10px;
                }
              }
            }
          }
          .el-icon-caret-bottom {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -6px;
            font-size: 30px;
          }
          .el-icon-caret-top {
            display: none;
          }
        }
        .eventActiveBoxRight {
          left: -50%;
          z-index: 100000000000;
        }
        .eventActiveBoxBottom {
          top: 100%;
          z-index: 100000000000;
          transform: translateY(0);
          .eventMessageBox {
            transform: translateY(11px);
          }
          .el-icon-caret-bottom {
            display: none;
          }
          .el-icon-caret-top {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -9px;
            font-size: 30px;
            display: inline;
          }
        }
      }
      ::v-deep .fc-day-grid .fc-row {
        overflow: visible;
      }
      ::v-deep .ScteListWrap {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1000;
        .ScteWrap {
          width: 100%;
          background-color: #333;
          color: #fff;
          text-align: center;
          font-size: 12px;
          position: absolute;
          p {
            width: 100%;
            height: 100%;
            overflow: hidden;
          }
          span {
            position: absolute;
            right: 10px;
            top: 0;
            i {
              color: #fff;
            }
          }
        }
        .ScteWrap::after {
          content: '';
          border-width: 5px 10px;
          border-style: solid;
          border-color: transparent rgba(255, 255, 255) transparent transparent;
          position: absolute;
          top: -5px;
          right: -10px;
        }
        .ScteWrap::before {
          content: '';
          border-width: 5px 10px;
          border-style: solid;
          border-color: transparent transparent transparent rgba(255, 255, 255);
          position: absolute;
          bottom: -5px;
          right: -20px;
        }
      }
      ::v-deep .SourceBlankPoint {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 2000;
        .BlankPoint {
          position: absolute;
          bottom: -40px;
          left: 0px;
          border-radius: 4px;
          padding: 8px;
          z-index: 2000;
          font-size: 12px;
          line-height: 1;
          width: fit-content;
          white-space: nowrap;
          background: #303133;
          color: #FFFFFF;
          display: none;
        }
        .BlankPoint::after {
          content: '';
          border: 5px solid transparent;
          border-top-color: #303133;
          border-right-color: #303133;
          position: absolute;
          left: 10px;
          top: -4px;
          transform: rotate(-45deg);
        }
        i {
          font-size: 12px;
          color: #EC5050;
        }
      }
      ::v-deep .SourceBlankPoint:hover .BlankPoint {
        display: block;
      }
    }
  }
  .magnifying .body::-webkit-scrollbar-thumb {
    display: none;
  }
}
</style>
